(function() {
  'use strict';

  angular
    .module('vinelib', [
        'ui.router',
        'ngAnimate',
        'ngCookies',
        'ngTouch',
        'ngSanitize',
        'ngMessages',
        'ngAria',
        'restangular',
        'ui.bootstrap',
        'rex-string-helper', //Str
        'angular-jwt',
        'ngAside', //Side Menu
        'formly',
        'formlyBootstrap',
        'textAngular',
        'as.sortable',
        'angularSpinner'
    ]);

})();

(function() {
  'use strict';

  angular
    .module('vinelib')
    .controller('SearchController', SearchController);

  /** @ngInject */
  function SearchController($stateParams, resourceService) {
    var vm = this;
    
    vm.searchTerm = resourceService.data.searchTerm;
    vm.results = resourceService.data.searchResults;
    vm.searching = resourceService.data.searching;

    resourceService.search( $stateParams.searchTerm );
  }
})();

(function() {
  'use strict';

  angular
    .module('vinelib')
    .controller('ResourceController', ResourceController);

  /** @ngInject */
  function ResourceController(resourceModel) {
    var vm = this;
    vm.resource = [];
    vm.currentYear = new Date().getFullYear();

    loadResource();

    function loadResource() {
      //Get data via model - now preloaded in state
      // assign resource properties directly to vm since it has the same name
      angular.extend( vm, resourceModel ); //didn't do it with Object.assign(vm, data); as no IE support. watch out for arrays
      vm.author = vm.author.data;
      vm.comments = vm.comments.data;
      vm.categories = vm.categories.data;
    }
  }
})();

(function() {
  'use strict';

  angular
    .module('vinelib')
    .controller('ProfileController', ProfileController);

  /** @ngInject */
  function ProfileController($stateParams) {
    var vm = this;
    vm.formtype = $stateParams.formtype;
  }
})();

(function() {
  'use strict';

  angular
    .module('vinelib')
    .controller('PasswordController', PasswordController);

  /** @ngInject */
  function PasswordController($timeout, $state, $stateParams, userService ) {
    var vm = this;
    vm.model = {};

    loadData();

    function loadData() {
      // load the data from $stateParams if appropriate
      if( $state.current.name === 'password-change' ) {
        vm.model.email = $stateParams.email;
        vm.model.token = $stateParams.token;

        if( ! vm.model.token ) {
          showMessage('This form only works when it is opened from Password Reset email. If you have forgotton your password, please go to the login page and click Forgot Password.', 'error');
        }
      }
    }


    vm.passwordResetFields = [
      {
        key: 'email',
        type: 'input',
        templateOptions: {
          type: 'email',
          label: 'Email address',
          placeholder: 'Enter email',
          required: true,
          text: 'Please enter the email address you registered with and we\'ll send you an email with a link to reset your password'
        }
      }
    ];

    vm.onResetSubmit = function() {
      userService.sendPasswordEmail(vm.model)
        .then( function() {
          showMessage("We've sent you an email with a link to reset your password",'success');
        }, function() {
          showMessage("There was an error resetting your password. This usually occurs when your email address is not in our system",'error');
        }
      );
    }

    vm.passwordChangeFields = [
      {
        key: 'email',
        type: 'input',
        templateOptions: {
          type: 'hidden',
          required: true
        }
      },
      {
        key: 'token',
        type: 'input',
        templateOptions: {
          type: 'hidden',
          required: true
        }
      },
      {
        key: 'password',
        type: 'input',
        templateOptions: {
          type: 'password',
          label: 'New Password',
          placeholder: 'Please enter a new password that is 8 or more characters',
          required: true
        },
        validators:{
          minLength: '$viewValue.length >=8'
        }
      },
      {
        key: 'password_confirmation',
        type: 'input',
        templateOptions: {
          type: 'password',
          label: 'Confirm Password',
          required: true
        }
      }      
    ];
    
    vm.onChangeSubmit = function() {
      if( vm.model.password !== vm.model.password_confirmation ) {
        showMessage("Please ensure your passwords match", 'error');
        return false;
      }

      userService.resetPassword(vm.model)
        .then( function() {
          showMessage("Password Successfully Reset",'success');
          loginUser(vm.model);
        }, function() {
          showMessage("There was an error resetting your password.",'error');
        }
      );
    }

     function loginUser(data) {
      userService.login( data )
        .then(function() {
          $state.go('home');
        }, function() {
          showMessage("There was an error logging in. Please report this error to info@thevineproject.com", 'error');
        }
      );
    }

    function showMessage(message, style) {
      vm.messageClass = style==='error' ? 'alert-danger' : 'alert-success';
      vm.messageMessage = message;
    }
  }
})();

(function() {
  'use strict';

  angular
    .module('vinelib')
    .controller('MembershipController', MembershipController);

  /** @ngInject */
  function MembershipController($stateParams) {
    var vm = this;
    vm.page = $stateParams.page;
    vm.formtype = $stateParams.formtype;
  }
})();

(function() {
  'use strict';

  angular
    .module('vinelib')
    .controller('MediaController', MediaController);

  /** @ngInject */
  function MediaController($stateParams, $scope, Media, Restangular) {
    var vm = this;
    vm.message = $stateParams.message;

    vm.medias = [];
    vm.mediaToEdit = null;
    vm.formFields = [];
    vm.pagination;

    loadAllMedia();
    loadFormFields();

    //Listen for file Uploads
    var unlisten = $scope.$on('fileToUpload', function(event, arg) {
      vm.fileToUpload = arg;
    });

    // remove the listener
    $scope.$on('$destroy', unlisten);

    vm.onEditSubmit = function() {
      Media.uploadFile( vm.mediaToEdit, vm.fileToUpload )
        .then( function(data) {
          if( vm.indexToEdit === null ) {
            vm.medias.push(data);
          } else {
            vm.medias[ vm.indexToEdit ] = data;
          }
          vm.mediaToEdit = null;
        });
    }

    vm.editMedia = function(media) {
      vm.mediaToEdit = media;
      vm.indexToEdit = vm.medias.indexOf(media);
    };

    vm.addNewImage = function() {
      vm.mediaToEdit = {
        'media_type': 'general',
        'resource_id': 0
      };
      vm.indexToEdit = null;
    };

    vm.removeImage = function() {
      Restangular.restangularizeElement(null, vm.mediaToEdit, 'media');
      vm.mediaToEdit.remove()
        .then( function() {
          vm.mediaToEdit = null;
          vm.medias.splice( vm.indexToEdit, 1);
        });
    }

    vm.pageChanged = function() {
      loadAllMedia();
    };

    function loadAllMedia() {
      var params = {
        page: vm.pagination,
        type: 'general'
      }

      return Media.getList(params).then(function(data){
        vm.medias = data;
      }); 
    }

    function loadFormFields() {
      vm.formFields = [
        {
          key: 'title',
          type: 'input',
          templateOptions: {
            type: 'text',
            label: 'Title',
            placeholder: 'Enter the Title of this Media',
            required: true
          }
        },
        {
          key: 'file',
          type: 'upload',
          templateOptions: {
            label: 'Media File',
            required: true
          }
        }
      ];
    }
  }
})();

(function() {
  'use strict';

  angular
    .module('vinelib')
    .controller('HomeController', HomeController);

  /** @ngInject */
  function HomeController($stateParams, resourceService, userService, configService, $state) {
    var vm = this;
    vm.user = userService.currentUser;
    vm.categorySlug = $stateParams.categorySlug ? $stateParams.categorySlug : 'phaseresources';

    vm.interface = configService.getLocalConfig( 'interface' );

    vm.resources = resourceService.data.featuredResources;

    vm.openSignup = function() {
       $state.go('join.info');
    }
  }
})();

(function() {
  'use strict';

  angular
    .module('vinelib')
    .controller('EditresourceController', EditresourceController);

  /** @ngInject */
  function EditresourceController($stateParams, $scope, Media, Restangular, $state, resource, Resource, Str, $log) {
    var vm = this;
    vm.message = $stateParams.message;

    //The resource to Edit
    vm.resource = {};

    //Is this an existing resource (or a new one)\
    vm.isExisting = false;

    vm.resourceCategoryIds = [];
    vm.formFields = [];
    vm.mediaToEdit = null;
    init();

    vm.onEditSubmit = function() {
      var promise;
      clearMessage();
      promise = updateResource();

      promise.then( function() {
        showMessage('Saved Resource','success');
        vm.editresourceForm.$setPristine();
      }, function(response) {
        $log.error(response);
        showMessage(response.response.data.message,'error');
      });
    }

    vm.deleteResource = deleteResource;

    /**
     * Choose which categories are added to this resource
     * @param  {obj} category
     * @return {null}
     */
    vm.toggleCategory = function(category) {
      if( category.selected ) {
        category.selected = false;
        removeCategoryFromResource(category);
      } else {
        addCategoryToResource(category);
        category.selected = true;
      }
    };

    vm.chooseUpdateImage = function() {
      vm.mediaToEdit = vm.resource.feature;
    };

    vm.chooseNewImage = function() {
      vm.mediaToEdit = vm.resource.feature;
      vm.mediaToEdit.media_type = 'feature';
      vm.mediaToEdit.resource_id = vm.resource.id;
    };

    vm.removeImage = function() {
      Restangular.restangularizeElement(null, vm.resource.feature, 'media');
      vm.resource.feature.remove()
        .then( function() {
          nullifyObject(vm.resource.feature);
        });
    }

    vm.onImageSubmit = function() {
      Media.uploadFile( vm.mediaToEdit, vm.fileToUpload )
        .then( function(data) {
          vm.resource.feature = data;
          vm.mediaToEdit = null;
        });
    }

    function init() {
      loadData();
      loadFormFields();

      //Listen for file Uploads
      var unlisten = $scope.$on('fileToUpload', function(event, arg) {
        vm.fileToUpload = arg;
      });

      // remove the listener
      $scope.$on('$destroy', unlisten);

    }

    function nullifyObject(obj) {
      for (var property in obj) {
        if (obj.hasOwnProperty(property)) {
          obj[property] = null;
        }
      }
    }
    /**
     * Loops through available categories and marks if it is selected or not
     */
    function markAvailableCategoriesAsSelected() {
      var resourceCategoryIds = [];
      var cats = vm.resource.availableCategories;

      for (var j = vm.resource.categories.data.length - 1; j >= 0; j--) {
        resourceCategoryIds.push( vm.resource.categories.data[j].id );
      }

      for (var i = cats.length - 1; i >= 0; i--) {
        for (var n = cats[i].children.length - 1; n >= 0; n--) {
          cats[i].children[n].selected = ( resourceCategoryIds.indexOf( cats[i].children[n].id ) !== -1 );
        }
      }
    }

    function removeCategoryFromResource(category) {
      var cats = vm.resource.categories.data;
      for (var i = cats.length - 1; i >= 0; i--) {
        if( category.id === cats[i].id ) {
          cats.splice(i, 1);
          return true;
        }
      }
    }

    function addCategoryToResource(category) {
      var cats = vm.resource.categories.data;
      for (var i = cats.length - 1; i >= 0; i--) {
        if( category.id === cats[i].id )
          return true;
      }

      cats.push({
        id:   category.id,
        slug: category.cat_slug,
        name: category.cat_name,
        show: category.show,
        desc: category.cat_description
      });
    }

    function updateResource() {
      if( vm.isExisting ) {
        vm.resource.use_method = 'PUT';
      } else {
        vm.resource = Resource.makeModel( vm.resource );
      }
      return vm.resource.post();
    }

    function deleteResource() {
      if( ! vm.isExisting )
        return false;

      vm.resource.remove()
        .then( function() {
          $state.go('admin.resources');
        });
    }

    function showMessage(message, style) {
      vm.resourceClass = style==='error' ? 'alert-danger' : 'alert-success';
      vm.resourceMessage = message;
    }
    
    function clearMessage() {
      vm.resourceMessage = '';
    }

    function loadData() {
      if(resource) { //pre-loaded in state
        if( resource.id )
          vm.isExisting = true;

        vm.resource = resource;
        markAvailableCategoriesAsSelected();
        if( vm.resource.feature.hasOwnProperty( 'data' ) ) {
          vm.resource.feature = vm.resource.feature.data;
        } else {
          vm.resource.feature = {};
        }
        // if( vm.resource.hasOwnProperty('author') ) {
        //   vm.resource.author_id = vm.resource.author.data.id;
        // }
        vm.resource.availableAuthors = vm.resource.availableAuthors.data;
      }
    }

    function loadFormFields() {
      vm.formFields = [
        {
          key: 'title',
          type: 'input',
          templateOptions: {
            type: 'text',
            label: 'Title',
            placeholder: 'Enter the Title of this Resource',
            required: true
          },
          watcher: {
            listener: function() {
              if( !vm.resource.id ) {
                var title = vm.resource.title;
                if( title ) {
                  vm.resource.slug = Str.toSlug(title);
                }
              }
            }
          }
        },
        {
          key: 'slug',
          type: 'input',
          templateOptions: {
            type: 'text',
            label: 'Slug',
            placeholder: 'Enter url-friendly name for this resource',
            required: true
          }
        },
        {
          key: 'description',
          type: 'input',
          templateOptions: {
            type: 'text',
            label: 'Description',
            required: true
          }
        },
        {
          key: 'hide_feature',
          type: 'checkbox',
          templateOptions: {
            label: 'Hide Feature Image from page (still shows as thumbnail)'
          }
        },
        {
          key: "author_id",
          type: "select",
          templateOptions: {
            label: "Author",
            valueProp: "user_id",
            labelProp: "firstname",
            options: vm.resource.availableAuthors
          }
        },
        {
          key: "type",
          type: "select",
          templateOptions: {
            label: "Resource Type",
            valueProp: "type",
            labelProp: "type",
            options: [
              { type: 'article' },
              { type: 'video' },
              { type: 'podcast' },
              { type: 'file' }
            ]
          }
        },
        {
          key: "status",
          type: "select",
          templateOptions: {
            label: "Status",
            valueProp: "status",
            labelProp: "status",
            options: [
              { status: 'draft' },
              { status: 'publish' }
            ]
          }
        },
        {
          key: 'content',
          type: 'editor',
          templateOptions: {
            label: 'Content',
            required: true
          }
        }
      ];
    }

    vm.mediaFormFields = [
      {
        key: 'title',
        type: 'input',
        templateOptions: {
          type: 'text',
          label: 'Title',
          placeholder: 'Enter a Title for this Image',
          required: true
        }
      },
      {
        key: 'file',
        type: 'upload',
        templateOptions: {
          label: 'Media File',
          required: true
        }
      }
    ];

  }
})();

(function() {
  'use strict';

  angular
    .module('vinelib')
    .controller('EditcategoryController', EditcategoryController);

  /** @ngInject */
  function EditcategoryController($stateParams, Category, $uibModal, Str) {
    var vm = this;
    vm.message = $stateParams.message;
    vm.orderChanged = false;
    vm.categoryToEdit = null;
    vm.indexToEdit;

    vm.categories;
    init();

    vm.dragControlListeners = {
        // accept: function (sourceItemHandleScope, destSortableScope) {return boolean}//override to determine drag is allowed or not. default is true.
        itemMoved: function() {
          vm.orderChanged = true;
        },
        orderChanged: function(event) {
          event.source.itemScope.child.highlight = false;
          vm.orderChanged = true;
        },
        allowDuplicates: false
    };

    vm.saveCategoryOrder = function() {
      if( ! vm.orderChanged )
        return false;

      Category.updateOrder( mapCategoryIds() )
        .then( function() {
          vm.orderChanged = false;
        });
    };

    vm.newCategory = function() {
      var category = {
        id: null,
        slug: null,
        name: null,
        desc: null,
        resources_count: '0',
        parent_id: vm.categories[0].id //Get the id of the first parent
      };
      vm.categoryToEdit = category;
      vm.categoryToEdit = Category.makeModel(vm.categoryToEdit);
      vm.indexToEdit = null;
    };

    vm.editCategory = function(child, parent) {
      vm.categoryToEdit = child;
      vm.categoryToEdit = Category.makeModel(vm.categoryToEdit);
      vm.indexToEdit = {
        parent: vm.categories.indexOf(parent),
        child: parent.children.indexOf(child)
      };
    };

    vm.onEditSubmit = function() {
      var isNew = ( vm.categoryToEdit.id === null );
      vm.categoryToEdit.save()
        .then( function(data) {
          vm.categoryToEdit = data;
          if( isNew ) {
            vm.categoryToEdit.highlight = true;
            vm.categories[0].children.unshift( vm.categoryToEdit );
          }
          vm.categoryToEdit = null;
        });
    }

    vm.removeCategory = function() {
      var modalInstance = $uibModal.open({
        animation: true,
        ariaLabelledBy: 'modal-title',
        ariaDescribedBy: 'modal-body',
        templateUrl: 'categoryModal.html',
        controller: 'CategoryModalController',
        controllerAs: 'categoryModalCtrl',
        // size: size,
        resolve: {
          category: function () {
            return vm.categoryToEdit;
          }
        }
      });

      modalInstance.result.then(function () {
        vm.categoryToEdit.remove()
          .then( function() {
            vm.categoryToEdit = null;
            vm.categories[ vm.indexToEdit.parent ].children.splice( vm.indexToEdit.child, 1);
          });
      });

    };

    function init() {
      loadData();
      loadFormFields();
    }

    function mapCategoryIds() {
      var data = [];
      var item = {};
      var children =[];

      for (var i = 0; i < vm.categories.length; i++) {
        item = { id: vm.categories[i].id };
        children = [];
        for (var j = 0; j < vm.categories[i].children.length; j++) {
          children.push( vm.categories[i].children[j].id );
        }
        item.children = children;
        data.push( item );
      }

      return data;
    }

    function loadData() {
      Category.getList({include: "children",toplevel: true}).then( function(data) {
        for (var i = 0; i < data.length; i++) {
          data[i].children = data[i].children.data; //promote the children.data property
        }
        vm.categories = data;
      });
    }

    function loadFormFields() {
      vm.formFields = [
        {
          key: 'name',
          type: 'input',
          templateOptions: {
            type: 'text',
            label: 'Category Name',
            placeholder: 'Enter the short but useful name for this category',
            required: true
          },
          watcher: {
            listener: function() {
              if( vm.categoryToEdit.id === null ) {
                var name = vm.categoryToEdit.name;
                if( name ) {
                  vm.categoryToEdit.slug = Str.toSlug(name);
                }
              }
            }
          }

        },
        {
          key: 'desc',
          type: 'textarea',
          templateOptions: {
            label: 'Description',
            placeholder: 'A description of what this category should hold'
          }
        },
        {
          key: 'slug',
          type: 'input',
          templateOptions: {
            type: 'text',
            label: 'URL Slug',
            placeholder: 'The link to this category that\'s seen in the URL',
            required: true
          }
        }
      ];
    }
  }

  angular
    .module('vinelib')
    .controller('CategoryModalController', CategoryModalController);

  /** @ngInject */
  function CategoryModalController($uibModalInstance, category) {
    var vm = this;
    vm.category = category;
    vm.alert = {};

    if( vm.category.resources_count > 0 ) {
      vm.alert.title = 'Can\'t delete while resources belong to this category';
      vm.alert.body = 'This category contains ' + vm.category.resources_count + ' resource(s). Please ensure this category is empty before deleting it.';
      vm.alert.showOk = false;
    } else {
      vm.alert.title = 'Are you sure you want to delete this category';
      vm.alert.body = 'There are currently no resources assigned to this category, so it\'s fine to delete it. Just wanted to check!';
      vm.alert.showOk = true;
    }

    vm.ok = function () {
      $uibModalInstance.close();
    };

    vm.cancel = function () {
      $uibModalInstance.dismiss('cancel');
    };
  }
})();

(function() {
  'use strict';

  angular
    .module('vinelib')
    .controller('CategoryController', CategoryController);

  /** @ngInject */
  function CategoryController($stateParams, Category) {
    var vm = this;

    loadPagedata();

    function loadPagedata() {
      //Setup query parameters
      var params = {
        include: 'resources'
      }

      //Get data via model
      Category.get($stateParams.categorySlug,params).then(function(data){
        vm.category = data;
        vm.resources = data.resources.data;
      });        
    }

  }
})();

(function() {
  'use strict';

  angular
    .module('vinelib')
    .controller('AdminresourcesController', AdminresourcesController);

  /** @ngInject */
  function AdminresourcesController(Resource) {
    var vm = this;

    vm.resources = [];
    vm.pagination;

    vm.pageChanged = function() {
      loadResources();
    };

    init();

    function init() {
      loadResources();
    }

    function loadResources() {
      var params = {
        all: true, //return drafts, unpublished, etc
        page: vm.pagination
      }

      return Resource.getList(params).then(function(data){
        vm.resources = data;
      }); 
    }
  }
})();

(function() {
  'use strict';

  angular
    .module('vinelib')
    .directive('vgSidebar', vgSidebar);

  /** @ngInject */
  function vgSidebar() {
    var directive = {
      restrict: 'E',
      scope: {
          // sidebarSlug: '@sidebarSlug',
          // templateType: '@templateType'
      },
      templateUrl: 'app/components/sidebar/sidebar.html',
      controller: SidebarController,
      controllerAs: 'vm',
      bindToController: true
    };

    return directive;

    /** @ngInject */
    function SidebarController() {
      // var vm = this;

      // Category.get(vm.sidebarSlug, {include: "children"})
      //   .then(function(data){
      //     vm.parent = data;
      //     vm.categories = vm.parent.children.data;
      //   });

    }
  }

})();

(function() {
  'use strict';

  angular
    .module('vinelib')
    .directive('vgResourceGrid', vgResourceGrid);

  /** @ngInject */
  function vgResourceGrid() {
    var directive = {
      restrict: 'E',
      templateUrl: 'app/components/resourceGrid/resourceGrid.html',
      scope: {
          resources: '='
      },
      controller: ResourceGridController,
      controllerAs: 'vm',
      bindToController: true
    };

    return directive;

    /** @ngInject */
    function ResourceGridController(Str, $state, modalService) {
      var vm = this;

      vm.getButtonText = function( resource ) {
        var map = {
          article: 'Read',
          file: 'Download',
          video: 'Watch',
          audio: 'Listen'
        }
        if( resource.availability === 'access' )
          return map[ resource.type ] + ' Now';
        
        if( resource.availability === 'upgrade' )
          return 'Upgrade to ' + map[ resource.type ];

        return 'Join to ' + map[ resource.type ];
      }

      vm.resourceAction = function( $event, resource ) {
        $event.preventDefault();
        if( resource.availability === 'access' ) {
          $state.go( 'resource', { resourceSlug: resource.slug } );
        } else if( resource.availability === 'upgrade' ) {
          vm.openUpgrade();
        } else {
          vm.openSignup();
        }
      }

      vm.buttonClass = function( resource ) {
        if( resource.availability === 'access' )
          return 'btn-info';

        return 'btn-warning';
      }

      vm.capitalise = function( string ) {
        return Str.toUpperFirstChar( string );
      }

      //APFix: need to move this to parent controller or service
      vm.openSignup = function() {
        var modalOptions = {
            headerText: 'Become a member of The Vine Project Resource Library for Free',
            bodyTemplate: '/formSignup.html'
        };

        modalService.show({}, modalOptions);
      }

      vm.openUpgrade = function() {
        var modalOptions = {
            headerText: 'Upgrade to a full membership for Free',
            bodyTemplate: '/formUpgrade.html'
        };

        modalService.show({}, modalOptions);
      }
    }
  }

})();

(function() {
  'use strict';

  angular
    .module('vinelib')
    .directive('vineNavbar', vineNavbar);

  /** @ngInject */
  function vineNavbar() {
    var directive = {
      restrict: 'E',
      templateUrl: 'app/components/navbar/navbar.html',
      controller: NavbarController,
      controllerAs: 'vm',
      bindToController: true
    };

    return directive;

    /** @ngInject */
    function NavbarController($rootScope, modalService, $state, userService, categoryService, $aside, $timeout) {
      var vm = this;
      vm.user = userService.currentUser;
      vm.modalInstance;
      vm.currentMenuOpen = null;
      vm.searchOpen = false;
      vm.searchTerm;
      vm.loginData = {};

      init();

      //APFix: need to move this to parent controller or service
      vm.openLogin = function () {
        vm.closeMenu();
        modalService.close();
        var modalOptions = {
            headerText: 'Login to the Resource Library',
            bodyTemplate: '/loginTemplate.html',
            user: {}
        };

        vm.modalInstance = modalService.show({}, modalOptions);
      };

      // vm.chooseMemberType = function(memberType) {
      //   modalService.close();
      //   var modalOptions = {
      //       headerText: 'Become a member of The Vine Project Resource Library for Free',
      //       bodyTemplate: '/formSignup.html',
      //       memberType: memberType
      //   };

      //   modalService.show({}, modalOptions);
      // }

      vm.performSearch = function() {
        vm.searchOpen = false;
        vm.closeMenu();
        $state.go('search', {searchTerm: vm.searchTerm});
      }

      vm.loginFields = [
        {
          key: 'email',
          type: 'input',
          templateOptions: {
            showOn: ['signup', 'profile'],
            type: 'email',
            label: 'Email address',
            placeholder: 'Enter email',
            required: true
          }
        },
        {
          key: 'password',
          type: 'input',
          templateOptions: {
            showOn: ['signup', 'profile'],
            type: 'password',
            label: 'Password',
            required: true
          }
        }
      ];

      vm.loginMessage;

      vm.submitLoginForm = function() {
        var promise = userService.login( vm.loginData );
        vm.loginMessage = null;

        promise.then(function() {
          vm.loginClass = 'alert-success';
          vm.loginMessage = 'Success';
          $timeout( function(){
            modalService.close();
            vm.loginData = {};
            vm.loginMessage = null;
             $state.go('home');
          }, 1000 );
        }, function(response) {
          vm.loginClass = 'alert-danger';
          vm.loginMessage = response.message;
        });
      }
    
      vm.logoutUser = function () {
        vm.closeMenu();
        userService.logout();
      }

      //APFix: Duplicated
      vm.openSignup = function() {
        modalService.close();
        var modalOptions = {
            headerText: 'Become a member of The Vine Project Resource Library for Free',
            bodyTemplate: '/formSignup.html'
        };

        modalService.show({}, modalOptions);
      }
      
      vm.toggleMenuItem = function(slug) {
        vm.currentMenuOpen = (vm.currentMenuOpen === slug ) ? null : slug;
      }

      vm.openMenu = function(placement, backdrop) {

        vm.modalInstance = $aside.open({
          templateUrl: 'app/components/navbar/menu.html',
          placement: placement,
          size: 'sm',
          backdrop: backdrop
        });

      }

      //APFix - should probably introduce a global stateful way of doing this
      vm.closeMenu = function() {
        if( vm.modalInstance )
          vm.modalInstance.close();
      }

      function init() {
        vm.categories = categoryService.menuCategories;
        
        var removeStateWatch = $rootScope.$on('$stateChangeStart', function(){
          modalService.close();
        });

        vm.$onDestroy = function () {
          removeStateWatch();
        }
      }
    }
  }

})();
(function() {
  'use strict';

  angular.module('vinelib').service('modalService', modalService);
  
  /** @ngInject */
  function modalService($uibModal) {

    var modalDefaults = {
        backdrop: true,
        keyboard: true,
        modalFade: true,
        templateUrl: 'app/components/modal/modal.html'
    };

    var modalOptions = {
        headerText: 'Title'
    };

    var modalInstance;

    this.show = function (customModalDefaults, customModalOptions) {
        //Create temp objects to work with since we're in a singleton service
        var tempModalDefaults = {};
        var tempModalOptions = {};

        //Map angular-ui modal custom defaults to modal defaults defined in service
        angular.extend(tempModalDefaults, modalDefaults, customModalDefaults);

        //Map modal.html $scope custom properties to defaults defined in service
        angular.extend(tempModalOptions, modalOptions, customModalOptions);

        if (!tempModalDefaults.controller) {
            tempModalDefaults.controller = function ($scope, $uibModalInstance) {
                $scope.modalOptions = tempModalOptions;
                $scope.modalOptions.ok = function (result) {
                    $uibModalInstance.close(result);
                };
                $scope.modalOptions.close = function () {
                    $uibModalInstance.dismiss('cancel');
                };
            }
        }

        modalInstance = $uibModal.open(tempModalDefaults);//.result;
        return modalInstance;
    };

    this.close = function() {
        if( modalInstance )
            modalInstance.close();
    }
  }
})();
(function() {
  'use strict';

  angular
  .module('vinelib')
  .config(config);

  config.$inject = ['formlyConfigProvider'];
  /* @ngInject */
  function config(formlyConfigProvider) {
    "ngInject";
    /**
     * Add Field Type 'Description'
     * @type {String}
     */
    formlyConfigProvider.setType({
      name: 'description',
      templateUrl: 'app/components/forms/description.html',
      wrapper: ['bootstrapLabel']
    });

    /**
     * Add Field Type 'editor'
     * @type {String}
     */
    formlyConfigProvider.setType({
      name: 'editor',
      templateUrl: 'app/components/forms/editor.html',
      wrapper: ['bootstrapLabel']
    });

    /**
     * Add Field Type 'ReadOnly'
     * @type {String}
     */
    formlyConfigProvider.setType({
      name: 'readonly',
      templateUrl: 'app/components/forms/readonly.html'
    });

    /**
     * Add Field Type 'Divider'
     * @type {String}
     */
    formlyConfigProvider.setType({
      name: 'divider',
      templateUrl: 'app/components/forms/divider.html'
    });

    /**
     * Add Field Type 'Upload'
     * @type {String}
     */
    formlyConfigProvider.setType({
      name: 'upload',
      extends: 'input',
      wrapper: ['bootstrapLabel', 'bootstrapHasError'],
      link: function(scope, el) {
        el.on("change", function(changeEvent) {
          var file = changeEvent.target.files[0];
          if (file) {
            scope.$emit('fileToUpload', file);
            var fileProp = {};
            for (var properties in file) {
              if (!angular.isFunction(file[properties])) {
                fileProp[properties] = file[properties];
              }
            }
            scope.fc.$setViewValue(fileProp);
          } else {
            scope.fc.$setViewValue(undefined);
          }
        });
        el.on("focusout", function() {
          scope.fc.$validate();
        });
        
      },
      defaultOptions: {
        templateOptions: {
          type: 'file',
          required: true
        }
      }
    });
  }
})();
(function() {
  'use strict';

  angular
  .module('vinelib')
  .directive('vgFormSignup', vgFormSignup);

  /** @ngInject */
  function vgFormSignup() {
    var directive = {
      restrict: 'E',
      scope: {
        categorySlug: '@categorySlug',
        templateType: '@templateType',
        formType: '@'
      },
      templateUrl: 'app/components/formSignup/formSignup.html',
      controller: formSignupController,
      controllerAs: 'vm',
      bindToController: true
    };

    return directive;

    /** @ngInject */
    function formSignupController( $log, modalService, userService, $location, $anchorScroll, usSpinnerService, $state ) {
      var vm = this;

      function init() {
        vm.user = userService.currentUser;

        if( vm.formType == 'upgrade' ) //Set to upgrade by default
            vm.user.user.fullMember = true;

        if( vm.formType == 'full' ) { //Set to full membership type, but still use signup form
            vm.formType = 'signup';
            vm.user.user.fullMember = true;
        }

        //Subscribe by default
        vm.user.user.subscribeGotherefor = true;

        vm.userFields = chooseFields();
        
        vm.user.user.statesFieldHasOptions = false;

      }

      //APFix: need to move this to parent controller or service
      vm.openLogin = function () {
        modalService.close();
        
        var modalOptions = {
            headerText: 'Login to the Resource Library',
            bodyTemplate: '/loginTemplate.html',
            user: {}
        };

        vm.modalInstance = modalService.show({}, modalOptions);

        vm.modalInstance.result.then(function (result) {
          if( typeof result === 'undefined' || typeof result.email === 'undefined' || typeof result.password === 'undefined' ) {
            $log.error("There was a problem with the login data");
            return false;
          }
          
          userService.login(result);
        });
      };

      var titleOptions = [
        {option: 'Mr'},
        {option: 'Mrs'},
        {option: 'Miss'},
        {option: 'Rev'},
        {option: 'Dr'}
      ];

      var timeframeOptions = [
        {option: 'started', label:'I have already started'},
        {option: 'week', label:'Within the next week'},
        {option: 'month', label:'Within the next month'},
        {option: '3months', label:'Within the next 3 months'},
        {option: '6months', label:'Within the next 6 months'},
        {option: '12months', label:'Within the next 12 months'}
      ];

      var roleOptions = [
        {option: "Senior Pastor/Minister"},
        {option: "Associate Pastor/Minister"},
        {option: "Women's Pastor/Minister"},
        {option: "Youth/Kids Pastor/Minister"},
        {option: "Student Pastor/Minister"},
        {option: "Elder/Lay leader"},
        {option: "Bishop"},
        {option: "Staff"},
        {option: "Trainee"},
        {option: "Board Member"},
        {option: "Director"},
        {option: "Principal"},
        {option: "Campus Staff Worker"},
        {option: "Other"}
      ];

      var denominationOptions = [
        {option: "Adventist"},
        {option: "Anglican"},
        {option: "Baptist"},
        {option: "Brethren"},
        {option: "Church of Christ"},
        {option: "Christian Reformed"},
        {option: "Congregational"},
        {option: "Episcopalian"},
        {option: "Evangelical Free Churches"},
        {option: "FIEC"},
        {option: "Lutheran"},
        {option: "Methodist"},
        {option: "Pentecostal"},
        {option: "Presbyterian"},
        {option: "Reformed"},
        {option: "Roman Catholic"},
        {option: "Southern Baptist"},
        {option: "Uniting"},
        {option: "Independent/non-denominational"},
        {option: "Parachurch"},
        {option: "Other"}
      ];

      var countryOptions = [
        {option: 'AU', label: "Australia"},
        {option: 'GB', label: "United Kingdom"},
        {option: 'US', label: "United States"},
        {option: '',   label: "=============="},
        {option: 'AF', label: "Afghanistan"},
        {option: 'AL', label: "Albania"},
        {option: 'DZ', label: "Algeria"},
        {option: 'AS', label: "American Samoa"},
        {option: 'AD', label: "Andorra"},
        {option: 'AO', label: "Angola"},
        {option: 'AI', label: "Anguilla"},
        {option: 'AQ', label: "Antarctica"},
        {option: 'AG', label: "Antigua And Barbuda"},
        {option: 'AR', label: "Argentina"},
        {option: 'AM', label: "Armenia"},
        {option: 'AW', label: "Aruba"},
        {option: 'AU', label: "Australia"},
        {option: 'AT', label: "Austria"},
        {option: 'AZ', label: "Azerbaijan"},
        {option: 'BS', label: "Bahamas"},
        {option: 'BH', label: "Bahrain"},
        {option: 'BD', label: "Bangladesh"},
        {option: 'BB', label: "Barbados"},
        {option: 'BY', label: "Belarus"},
        {option: 'BE', label: "Belgium"},
        {option: 'BZ', label: "Belize"},
        {option: 'BJ', label: "Benin"},
        {option: 'BM', label: "Bermuda"},
        {option: 'BT', label: "Bhutan"},
        {option: 'BO', label: "Bolivia"},
        {option: 'BA', label: "Bosnia And Herzegowina"},
        {option: 'BW', label: "Botswana"},
        {option: 'BV', label: "Bouvet Island"},
        {option: 'BR', label: "Brazil"},
        {option: 'IO', label: "British Indian Ocean Territory"},
        {option: 'BN', label: "Brunei Darussalam"},
        {option: 'BG', label: "Bulgaria"},
        {option: 'BF', label: "Burkina Faso"},
        {option: 'BI', label: "Burundi"},
        {option: 'KH', label: "Cambodia"},
        {option: 'CM', label: "Cameroon"},
        {option: 'CA', label: "Canada"},
        {option: 'CV', label: "Cape Verde"},
        {option: 'KY', label: "Cayman Islands"},
        {option: 'CF', label: "Central African Republic"},
        {option: 'TD', label: "Chad"},
        {option: 'CL', label: "Chile"},
        {option: 'CN', label: "China"},
        {option: 'CX', label: "Christmas Island"},
        {option: 'CC', label: "Cocos (Keeling) Islands"},
        {option: 'CO', label: "Colombia"},
        {option: 'KM', label: "Comoros"},
        {option: 'CG', label: "Congo"},
        {option: 'CD', label: "Congo, The Democratic Republic Of The"},
        {option: 'CK', label: "Cook Islands"},
        {option: 'CR', label: "Costa Rica"},
        {option: 'CI', label: "Cote D'Ivoire"},
        {option: 'HR', label: "Croatia (Local Name: Hrvatska)"},
        {option: 'CU', label: "Cuba"},
        {option: 'CY', label: "Cyprus"},
        {option: 'CZ', label: "Czech Republic"},
        {option: 'DK', label: "Denmark"},
        {option: 'DJ', label: "Djibouti"},
        {option: 'DM', label: "Dominica"},
        {option: 'DO', label: "Dominican Republic"},
        {option: 'TL', label: "Timor-Leste (East Timor)"},
        {option: 'EC', label: "Ecuador"},
        {option: 'EG', label: "Egypt"},
        {option: 'SV', label: "El Salvador"},
        {option: 'GQ', label: "Equatorial Guinea"},
        {option: 'ER', label: "Eritrea"},
        {option: 'EE', label: "Estonia"},
        {option: 'ET', label: "Ethiopia"},
        {option: 'FK', label: "Falkland Islands (Malvinas)"},
        {option: 'FO', label: "Faroe Islands"},
        {option: 'FJ', label: "Fiji"},
        {option: 'FI', label: "Finland"},
        {option: 'FR', label: "France"},
        {option: 'FX', label: "France, Metropolitan"},
        {option: 'GF', label: "French Guiana"},
        {option: 'PF', label: "French Polynesia"},
        {option: 'TF', label: "French Southern Territories"},
        {option: 'GA', label: "Gabon"},
        {option: 'GM', label: "Gambia"},
        {option: 'GE', label: "Georgia"},
        {option: 'DE', label: "Germany"},
        {option: 'GH', label: "Ghana"},
        {option: 'GI', label: "Gibraltar"},
        {option: 'GR', label: "Greece"},
        {option: 'GL', label: "Greenland"},
        {option: 'GD', label: "Grenada"},
        {option: 'GP', label: "Guadeloupe"},
        {option: 'GU', label: "Guam"},
        {option: 'GT', label: "Guatemala"},
        {option: 'GN', label: "Guinea"},
        {option: 'GW', label: "Guinea-Bissau"},
        {option: 'GY', label: "Guyana"},
        {option: 'HT', label: "Haiti"},
        {option: 'HM', label: "Heard And Mc Donald Islands"},
        {option: 'VA', label: "Holy See (Vatican City State)"},
        {option: 'HN', label: "Honduras"},
        {option: 'HK', label: "Hong Kong"},
        {option: 'HU', label: "Hungary"},
        {option: 'IS', label: "Iceland"},
        {option: 'IN', label: "India"},
        {option: 'ID', label: "Indonesia"},
        {option: 'IR', label: "Iran (Islamic Republic Of)"},
        {option: 'IQ', label: "Iraq"},
        {option: 'IE', label: "Ireland"},
        {option: 'IL', label: "Israel"},
        {option: 'IT', label: "Italy"},
        {option: 'JM', label: "Jamaica"},
        {option: 'JP', label: "Japan"},
        {option: 'JO', label: "Jordan"},
        {option: 'KZ', label: "Kazakhstan"},
        {option: 'KE', label: "Kenya"},
        {option: 'KI', label: "Kiribati"},
        {option: 'KP', label: "Korea, Democratic People's Republic Of"},
        {option: 'KR', label: "Korea, Republic Of"},
        {option: 'KW', label: "Kuwait"},
        {option: 'KG', label: "Kyrgyzstan"},
        {option: 'LA', label: "Lao People's Democratic Republic"},
        {option: 'LV', label: "Latvia"},
        {option: 'LB', label: "Lebanon"},
        {option: 'LS', label: "Lesotho"},
        {option: 'LR', label: "Liberia"},
        {option: 'LY', label: "Libyan Arab Jamahiriya"},
        {option: 'LI', label: "Liechtenstein"},
        {option: 'LT', label: "Lithuania"},
        {option: 'LU', label: "Luxembourg"},
        {option: 'MO', label: "Macau"},
        {option: 'MK', label: "Macedonia, Former Yugoslav Republic Of"},
        {option: 'MG', label: "Madagascar"},
        {option: 'MW', label: "Malawi"},
        {option: 'MY', label: "Malaysia"},
        {option: 'MV', label: "Maldives"},
        {option: 'ML', label: "Mali"},
        {option: 'MT', label: "Malta"},
        {option: 'MH', label: "Marshall Islands"},
        {option: 'MQ', label: "Martinique"},
        {option: 'MR', label: "Mauritania"},
        {option: 'MU', label: "Mauritius"},
        {option: 'YT', label: "Mayotte"},
        {option: 'MX', label: "Mexico"},
        {option: 'FM', label: "Micronesia, Federated States Of"},
        {option: 'MD', label: "Moldova, Republic Of"},
        {option: 'MC', label: "Monaco"},
        {option: 'MN', label: "Mongolia"},
        {option: 'ME', label: "Montenegro"},
        {option: 'MS', label: "Montserrat"},
        {option: 'MA', label: "Morocco"},
        {option: 'MZ', label: "Mozambique"},
        {option: 'MM', label: "Myanmar"},
        {option: 'NA', label: "Namibia"},
        {option: 'NR', label: "Nauru"},
        {option: 'NP', label: "Nepal"},
        {option: 'NL', label: "Netherlands"},
        {option: 'AN', label: "Netherlands Antilles"},
        {option: 'NC', label: "New Caledonia"},
        {option: 'NZ', label: "New Zealand"},
        {option: 'NI', label: "Nicaragua"},
        {option: 'NE', label: "Niger"},
        {option: 'NG', label: "Nigeria"},
        {option: 'NU', label: "Niue"},
        {option: 'NF', label: "Norfolk Island"},
        {option: 'MP', label: "Northern Mariana Islands"},
        {option: 'NO', label: "Norway"},
        {option: 'OM', label: "Oman"},
        {option: 'PK', label: "Pakistan"},
        {option: 'PW', label: "Palau"},
        {option: 'PA', label: "Panama"},
        {option: 'PG', label: "Papua New Guinea"},
        {option: 'PY', label: "Paraguay"},
        {option: 'PE', label: "Peru"},
        {option: 'PH', label: "Philippines"},
        {option: 'PN', label: "Pitcairn"},
        {option: 'PL', label: "Poland"},
        {option: 'PT', label: "Portugal"},
        {option: 'PR', label: "Puerto Rico"},
        {option: 'QA', label: "Qatar"},
        {option: 'RE', label: "Reunion"},
        {option: 'RO', label: "Romania"},
        {option: 'RU', label: "Russian Federation"},
        {option: 'RW', label: "Rwanda"},
        {option: 'KN', label: "Saint Kitts And Nevis"},
        {option: 'LC', label: "Saint Lucia"},
        {option: 'VC', label: "Saint Vincent And The Grenadines"},
        {option: 'WS', label: "Samoa"},
        {option: 'SM', label: "San Marino"},
        {option: 'ST', label: "Sao Tome And Principe"},
        {option: 'SA', label: "Saudi Arabia"},
        {option: 'SN', label: "Senegal"},
        {option: 'SR', label: "Serbia"},
        {option: 'SC', label: "Seychelles"},
        {option: 'SL', label: "Sierra Leone"},
        {option: 'SG', label: "Singapore"},
        {option: 'SK', label: "Slovakia (Slovak Republic)"},
        {option: 'SI', label: "Slovenia"},
        {option: 'SB', label: "Solomon Islands"},
        {option: 'SO', label: "Somalia"},
        {option: 'ZA', label: "South Africa"},
        {option: 'GS', label: "South Georgia, South Sandwich Islands"},
        {option: 'SS', label: "South Sudan"},
        {option: 'ES', label: "Spain"},
        {option: 'LK', label: "Sri Lanka"},
        {option: 'SH', label: "St. Helena"},
        {option: 'PM', label: "St. Pierre And Miquelon"},
        {option: 'SD', label: "Sudan"},
        {option: 'SR', label: "Suriname"},
        {option: 'SJ', label: "Svalbard And Jan Mayen Islands"},
        {option: 'SZ', label: "Swaziland"},
        {option: 'SE', label: "Sweden"},
        {option: 'CH', label: "Switzerland"},
        {option: 'SY', label: "Syrian Arab Republic"},
        {option: 'TW', label: "Taiwan"},
        {option: 'TJ', label: "Tajikistan"},
        {option: 'TZ', label: "Tanzania, United Republic Of"},
        {option: 'TH', label: "Thailand"},
        {option: 'TG', label: "Togo"},
        {option: 'TK', label: "Tokelau"},
        {option: 'TO', label: "Tonga"},
        {option: 'TT', label: "Trinidad And Tobago"},
        {option: 'TN', label: "Tunisia"},
        {option: 'TR', label: "Turkey"},
        {option: 'TM', label: "Turkmenistan"},
        {option: 'TC', label: "Turks And Caicos Islands"},
        {option: 'TV', label: "Tuvalu"},
        {option: 'UG', label: "Uganda"},
        {option: 'UA', label: "Ukraine"},
        {option: 'AE', label: "United Arab Emirates"},
        {option: 'GB', label: "United Kingdom"},
        {option: 'US', label: "United States"},
        {option: 'UM', label: "United States Minor Outlying Islands"},
        {option: 'UY', label: "Uruguay"},
        {option: 'UZ', label: "Uzbekistan"},
        {option: 'VU', label: "Vanuatu"},
        {option: 'VE', label: "Venezuela"},
        {option: 'VN', label: "Viet Nam"},
        {option: 'VG', label: "Virgin Islands (British)"},
        {option: 'VI', label: "Virgin Islands (U.S.)"},
        {option: 'WF', label: "Wallis And Futuna Islands"},
        {option: 'EH', label: "Western Sahara"},
        {option: 'YE', label: "Yemen"},
        {option: 'YU', label: "Yugoslavia"},
        {option: 'ZM', label: "Zambia"},
        {option: 'ZW', label: "Zimbabwe"}
      ];

      var stateOptions = [];

      var countryStates = {
        US: [
          {option: 'AL', label: "Alabama"},
          {option: 'AK', label: "Alaska"},
          {option: 'AZ', label: "Arizona"},
          {option: 'AR', label: "Arkansas"},
          {option: 'CA', label: "California"},
          {option: 'CO', label: "Colorado"},
          {option: 'CT', label: "Connecticut"},
          {option: 'DE', label: "Delaware"},
          {option: 'DC', label: "District of Columbia"},
          {option: 'FL', label: "Florida"},
          {option: 'GA', label: "Georgia"},
          {option: 'HI', label: "Hawaii"},
          {option: 'ID', label: "Idaho"},
          {option: 'IL', label: "Illinois"},
          {option: 'IN', label: "Indiana"},
          {option: 'IA', label: "Iowa"},
          {option: 'KS', label: "Kansas"},
          {option: 'KY', label: "Kentucky"},
          {option: 'LA', label: "Louisiana"},
          {option: 'ME', label: "Maine"},
          {option: 'MD', label: "Maryland"},
          {option: 'MA', label: "Massachusetts"},
          {option: 'MI', label: "Michigan"},
          {option: 'MN', label: "Minnesota"},
          {option: 'MS', label: "Mississippi"},
          {option: 'MO', label: "Missouri"},
          {option: 'MT', label: "Montana"},
          {option: 'NE', label: "Nebraska"},
          {option: 'NV', label: "Nevada"},
          {option: 'NH', label: "New Hampshire"},
          {option: 'NJ', label: "New Jersey"},
          {option: 'NM', label: "New Mexico"},
          {option: 'NY', label: "New York"},
          {option: 'NC', label: "North Carolina"},
          {option: 'ND', label: "North Dakota"},
          {option: 'OH', label: "Ohio"},
          {option: 'OK', label: "Oklahoma"},
          {option: 'OR', label: "Oregon"},
          {option: 'PA', label: "Pennsylvania"},
          {option: 'RI', label: "Rhode Island"},
          {option: 'SC', label: "South Carolina"},
          {option: 'SD', label: "South Dakota"},
          {option: 'TN', label: "Tennessee"},
          {option: 'TX', label: "Texas"},
          {option: 'UT', label: "Utah"},
          {option: 'VT', label: "Vermont"},
          {option: 'VA', label: "Virginia"},
          {option: 'WA', label: "Washington"},
          {option: 'WV', label: "West Virginia"},
          {option: 'WI', label: "Wisconsin"},
          {option: 'WY', label: "Wyoming"}
        ],
        AU: [
          {option: 'NSW', label: "New South Wales"},
          {option: 'VIC', label: "Victoria"},
          {option: 'QLD', label: "Queensland"},
          {option: 'SA', label: "South Australia"},
          {option: 'NT', label: "Northern Territory"},
          {option: 'ACT', label: "Australian Capital Territory"},
          {option: 'WA', label: "Western Australia"},
          {option: 'TAS', label: "Tasmania"}
        ],
        GB: [
          {option: 'englandBathAndNorthEastSomerset',        label: 'England - Bath and North East Somerset'},
          {option: 'englandBedfordshire',                    label: 'England - Bedfordshire'},
          {option: 'englandBlackburnWithDarwen',             label: 'England - Blackburn with Darwen'},
          {option: 'englandBlackpool',                       label: 'England - Blackpool'},
          {option: 'englandBournemouth',                     label: 'England - Bournemouth'},
          {option: 'englandBracknellForest',                 label: 'England - Bracknell Forest'},
          {option: 'englandBrightonAndHove',                 label: 'England - Brighton and Hove'},
          {option: 'englandBristol',                         label: 'England - Bristol'},
          {option: 'englandBuckinghamshire',                 label: 'England - Buckinghamshire'},
          {option: 'englandCambridgeshire',                  label: 'England - Cambridgeshire'},
          {option: 'englandCheshire',                        label: 'England - Cheshire'},
          {option: 'englandCornwall',                        label: 'England - Cornwall'},
          {option: 'englandCumbria',                         label: 'England - Cumbria'},
          {option: 'englandDarlington',                      label: 'England - Darlington'},
          {option: 'englandDerby',                           label: 'England - Derby'},
          {option: 'englandDerbyshire',                      label: 'England - Derbyshire'},
          {option: 'englandDevon',                           label: 'England - Devon'},
          {option: 'englandDorset',                          label: 'England - Dorset'},
          {option: 'englandDurham',                          label: 'England - Durham'},
          {option: 'englandEastRidingOfYorkshire',           label: 'England - East Riding of Yorkshire'},
          {option: 'englandEastSussex',                      label: 'England - East Sussex'},
          {option: 'englandEssex',                           label: 'England - Essex'},
          {option: 'englandGloucestershire',                 label: 'England - Gloucestershire'},
          {option: 'englandGreaterManchester',               label: 'England - Greater Manchester'},
          {option: 'englandHalton',                          label: 'England - Halton'},
          {option: 'englandHampshire',                       label: 'England - Hampshire'},
          {option: 'englandHartlepool',                      label: 'England - Hartlepool'},
          {option: 'englandHerefordshire',                   label: 'England - Herefordshire'},
          {option: 'englandHertfordshire',                   label: 'England - Hertfordshire'},
          {option: 'englandIsleOfWight',                     label: 'England - Isle of Wight'},
          {option: 'englandKent',                            label: 'England - Kent'},
          {option: 'englandKingstonUponHull',                label: 'England - Kingston upon Hull'},
          {option: 'englandLancashire',                      label: 'England - Lancashire'},
          {option: 'englandLeicester',                       label: 'England - Leicester'},
          {option: 'englandLeicestershire',                  label: 'England - Leicestershire'},
          {option: 'englandLincolnshire',                    label: 'England - Lincolnshire'},
          {option: 'englandLondon',                          label: 'England - London'},
          {option: 'englandLuton',                           label: 'England - Luton'},
          {option: 'englandMerseyside',                      label: 'England - Merseyside'},
          {option: 'englandMiddlesbrough',                   label: 'England - Middlesbrough'},
          {option: 'englandMiltonKeynes',                    label: 'England - Milton Keynes'},
          {option: 'englandNorfolk',                         label: 'England - Norfolk'},
          {option: 'englandNorthEastLincolnshire',           label: 'England - North East Lincolnshire'},
          {option: 'englandNorthLincolnshire',               label: 'England - North Lincolnshire'},
          {option: 'englandNorthSomerset',                   label: 'England - North Somerset'},
          {option: 'englandNorthYorkshire',                  label: 'England - North Yorkshire'},
          {option: 'englandNorthamptonshire',                label: 'England - Northamptonshire'},
          {option: 'englandNorthumberland',                  label: 'England - Northumberland'},
          {option: 'englandNottingham',                      label: 'England - Nottingham'},
          {option: 'englandNottinghamshire',                 label: 'England - Nottinghamshire'},
          {option: 'englandOxfordshire',                     label: 'England - Oxfordshire'},
          {option: 'englandPeterborough',                    label: 'England - Peterborough'},
          {option: 'englandPlymouth',                        label: 'England - Plymouth'},
          {option: 'englandPoole',                           label: 'England - Poole'},
          {option: 'englandPortsmouth',                      label: 'England - Portsmouth'},
          {option: 'englandReading',                         label: 'England - Reading'},
          {option: 'englandRedcarAndCleveland',              label: 'England - Redcar and Cleveland'},
          {option: 'englandRutland',                         label: 'England - Rutland'},
          {option: 'englandShropshire',                      label: 'England - Shropshire'},
          {option: 'englandSlough',                          label: 'England - Slough'},
          {option: 'englandSomerset',                        label: 'England - Somerset'},
          {option: 'englandSouthGloucestershire',            label: 'England - South Gloucestershire'},
          {option: 'englandSouthYorkshire',                  label: 'England - South Yorkshire'},
          {option: 'englandSouthampton',                     label: 'England - Southampton'},
          {option: 'englandSouthendOnSea',                   label: 'England - Southend-on-Sea'},
          {option: 'englandStaffordshire',                   label: 'England - Staffordshire'},
          {option: 'englandStocktonOnTees',                  label: 'England - Stockton-on-Tees'},
          {option: 'englandStokeOnTrent',                    label: 'England - Stoke-on-Trent'},
          {option: 'englandSuffolk',                         label: 'England - Suffolk'},
          {option: 'englandSurrey',                          label: 'England - Surrey'},
          {option: 'englandSwindon',                         label: 'England - Swindon'},
          {option: 'englandTorbay',                          label: 'England - Torbay'},
          {option: 'englandTyneAndWear',                     label: 'England - Tyne and Wear'},
          {option: 'englandWarrington',                      label: 'England - Warrington'},
          {option: 'englandWarwickshire',                    label: 'England - Warwickshire'},
          {option: 'englandWestBerkshire',                   label: 'England - West Berkshire'},
          {option: 'englandWestMidlands',                    label: 'England - West Midlands'},
          {option: 'englandWestSussex',                      label: 'England - West Sussex'},
          {option: 'englandWestYorkshire',                   label: 'England - West Yorkshire'},
          {option: 'englandWiltshire',                       label: 'England - Wiltshire'},
          {option: 'englandWindsorAndMaidenhead',            label: 'England - Windsor and Maidenhead'},
          {option: 'englandWokingham',                       label: 'England - Wokingham'},
          {option: 'englandWorcestershire',                  label: 'England - Worcestershire'},
          {option: 'englandYork',                            label: 'England - York'},
          {option: 'northernIrelandAntrim',                  label: 'Northern Ireland - Antrim'},
          {option: 'northernIrelandArds',                    label: 'Northern Ireland - Ards'},
          {option: 'northernIrelandArmagh',                  label: 'Northern Ireland - Armagh'},
          {option: 'northernIrelandBallymena',               label: 'Northern Ireland - Ballymena'},
          {option: 'northernIrelandBallymoney',              label: 'Northern Ireland - Ballymoney'},
          {option: 'northernIrelandBanbridge',               label: 'Northern Ireland - Banbridge'},
          {option: 'northernIrelandBelfast',                 label: 'Northern Ireland - Belfast'},
          {option: 'northernIrelandCarrickfergus',           label: 'Northern Ireland - Carrickfergus'},
          {option: 'northernIrelandCastlereagh',             label: 'Northern Ireland - Castlereagh'},
          {option: 'northernIrelandColeraine',               label: 'Northern Ireland - Coleraine'},
          {option: 'northernIrelandCookstown',               label: 'Northern Ireland - Cookstown'},
          {option: 'northernIrelandCraigavon',               label: 'Northern Ireland - Craigavon'},
          {option: 'northernIrelandDown',                    label: 'Northern Ireland - Down'},
          {option: 'northernIrelandDungannonAndSouthTyrone', label: 'Northern Ireland - Dungannon and South Tyrone'},
          {option: 'northernIrelandFermanagh',               label: 'Northern Ireland - Fermanagh'},
          {option: 'northernIrelandLarne',                   label: 'Northern Ireland - Larne'},
          {option: 'northernIrelandLimavady',                label: 'Northern Ireland - Limavady'},
          {option: 'northernIrelandLisburn',                 label: 'Northern Ireland - Lisburn'},
          {option: 'northernIrelandLondonderry',             label: 'Northern Ireland - Londonderry'},
          {option: 'northernIrelandMagherafelt',             label: 'Northern Ireland - Magherafelt'},
          {option: 'northernIrelandMoyle',                   label: 'Northern Ireland - Moyle'},
          {option: 'northernIrelandNewryAndMourne',          label: 'Northern Ireland - Newry and Mourne'},
          {option: 'northernIrelandNewtownabbey',            label: 'Northern Ireland - Newtownabbey'},
          {option: 'northernIrelandNorthDown',               label: 'Northern Ireland - North Down'},
          {option: 'northernIrelandOmagh',                   label: 'Northern Ireland - Omagh'},
          {option: 'northernIrelandStrabane',                label: 'Northern Ireland - Strabane'},
          {option: 'scotlandAberdeen',                       label: 'Scotland - Aberdeen'},
          {option: 'scotlandAberdeenshire',                  label: 'Scotland - Aberdeenshire'},
          {option: 'scotlandAngus',                          label: 'Scotland - Angus'},
          {option: 'scotlandArgyllAndBute',                  label: 'Scotland - Argyll and Bute'},
          {option: 'scotlandClackmannanshire',               label: 'Scotland - Clackmannanshire'},
          {option: 'scotlandDumfriesAndGalloway',            label: 'Scotland - Dumfries and Galloway'},
          {option: 'scotlandDundee',                         label: 'Scotland - Dundee'},
          {option: 'scotlandEastAyrshire',                   label: 'Scotland - East Ayrshire'},
          {option: 'scotlandEastDunbartonshire',             label: 'Scotland - East Dunbartonshire'},
          {option: 'scotlandEastLothian',                    label: 'Scotland - East Lothian'},
          {option: 'scotlandEastRenfrewshire',               label: 'Scotland - East Renfrewshire'},
          {option: 'scotlandEdinburgh',                      label: 'Scotland - Edinburgh'},
          {option: 'scotlandEileanSiar',                     label: 'Scotland - Eilean Siar'},
          {option: 'scotlandFalkirk',                        label: 'Scotland - Falkirk'},
          {option: 'scotlandFife',                           label: 'Scotland - Fife'},
          {option: 'scotlandGlasgow',                        label: 'Scotland - Glasgow'},
          {option: 'scotlandHighland',                       label: 'Scotland - Highland'},
          {option: 'scotlandInverclyde',                     label: 'Scotland - Inverclyde'},
          {option: 'scotlandMidlothian',                     label: 'Scotland - Midlothian'},
          {option: 'scotlandMoray',                          label: 'Scotland - Moray'},
          {option: 'scotlandNorthAyrshire',                  label: 'Scotland - North Ayrshire'},
          {option: 'scotlandNorthLanarkshire',               label: 'Scotland - North Lanarkshire'},
          {option: 'scotlandOrkneyIslands',                  label: 'Scotland - Orkney Islands'},
          {option: 'scotlandPerthAndKinross',                label: 'Scotland - Perth and Kinross'},
          {option: 'scotlandRenfrewshire',                   label: 'Scotland - Renfrewshire'},
          {option: 'scotlandScottishBorders',                label: 'Scotland - Scottish Borders'},
          {option: 'scotlandShetlandIslands',                label: 'Scotland - Shetland Islands'},
          {option: 'scotlandSouthAyrshire',                  label: 'Scotland - South Ayrshire'},
          {option: 'scotlandSouthLanarkshire',               label: 'Scotland - South Lanarkshire'},
          {option: 'scotlandStirling',                       label: 'Scotland - Stirling'},
          {option: 'scotlandWestDunbartonshire',             label: 'Scotland - West Dunbartonshire'},
          {option: 'scotlandWestLothian',                    label: 'Scotland - West Lothian'},
          {option: 'walesAnglesey',                          label: 'Wales - Anglesey'},
          {option: 'walesBlaenauGwent',                      label: 'Wales - Blaenau Gwent'},
          {option: 'walesBridgend',                          label: 'Wales - Bridgend'},
          {option: 'walesCaerphilly',                        label: 'Wales - Caerphilly'},
          {option: 'walesCardiff',                           label: 'Wales - Cardiff'},
          {option: 'walesCarmarthenshire',                   label: 'Wales - Carmarthenshire'},
          {option: 'walesCeredigion',                        label: 'Wales - Ceredigion'},
          {option: 'walesConwy',                             label: 'Wales - Conwy'},
          {option: 'walesDenbighshire',                      label: 'Wales - Denbighshire'},
          {option: 'walesFlintshire',                        label: 'Wales - Flintshire'},
          {option: 'walesGwynedd',                           label: 'Wales - Gwynedd'},
          {option: 'walesMerthyrTydfil',                     label: 'Wales - Merthyr Tydfil'},
          {option: 'walesMonmouthshire',                     label: 'Wales - Monmouthshire'},
          {option: 'walesNeathPortTalbot',                   label: 'Wales - Neath Port Talbot'},
          {option: 'walesNewport',                           label: 'Wales - Newport'},
          {option: 'walesPembrokeshire',                     label: 'Wales - Pembrokeshire'},
          {option: 'walesPowys',                             label: 'Wales - Powys'},
          {option: 'walesRhonddaCynonTaff',                  label: 'Wales - Rhondda Cynon Taff'},
          {option: 'walesSwansea',                           label: 'Wales - Swansea'},
          {option: 'walesTorfaen',                           label: 'Wales - Torfaen'},
          {option: 'walesValeOfGlamorgan',                   label: 'Wales - Vale of Glamorgan'},
          {option: 'walesWrexham',                           label: 'Wales - Wrexham'}
        ]
      };

      /**
       * Set the States Select options according to country
       * @param {str} countryCode
       * @return {bool} whether or not there are stateOptions for this country
       */
      function setStates(countryCode) {
        if( countryStates.hasOwnProperty(countryCode) ) {
          angular.copy(countryStates[countryCode],stateOptions);
          return true;
        }

        angular.copy([],stateOptions);
        return false;
      }

      var userFormOptions = {
        profile: {
          submit: 'Submit'
        },
        upgrade: {
          submit: 'Submit Upgrade'
        },
        signup: {
          submit: 'Join Now'
        }
        //full: not needed here as it gets converted to signup, but marks fullMember as checked
      };

      var userFields = [
        {
          key: 'type',
          type: 'readonly',
          templateOptions: {
            showOn: ['profile'],
            label: 'Member Type'
          }
        },
        {
          key: 'div1',
          type: 'divider',
          templateOptions: {
            showOn: ['profile']
          }
        },
        {
          key: 'firstname',
          type: 'input',
          templateOptions: {
            showOn: ['signup', 'upgrade', 'profile'],
            type: 'text',
            label: 'First Name',
            placeholder: 'Enter your first name',
            required: true
            // focus: true
          }
        },
        {
          key: 'lastname',
          type: 'input',
          templateOptions: {
            showOn: ['signup', 'upgrade', 'profile'],
            type: 'text',
            label: 'Last Name',
            placeholder: 'Enter your last name',
            required: true
          }
        },
        {
          key: 'email',
          type: 'input',
          templateOptions: {
            showOn: ['signup', 'profile'],
            type: 'email',
            label: 'Email address',
            placeholder: 'Enter email',
            required: true
          }
        },
        {
          key: 'password',
          type: 'input',
          templateOptions: {
            showOn: ['signup'],
            type: 'password',
            label: 'Password',
            placeholder: 'Enter a password that is more than 8 characters long',
            required: true
          },
          validators:{
            minLength: '$viewValue.length >=8'
          }
        },
        {
          key: 'password_confirmation',
          type: 'input',
          templateOptions: {
            showOn: ['signup'],
            type: 'password',
            label: 'Confirm Password'
          },
          hideExpression: "!model.password"
        },
        {
          key: 'newPassword',
          type: 'input',
          templateOptions: {
            showOn: ['profile'],
            type: 'password',
            label: 'Change Password',
            placeholder: 'If you would like to change your password, Enter a new password that is more than 8 characters long, otherwise, leave blank'
          }
        },
        {
          key: 'newPassword_confirmation',
          type: 'input',
          templateOptions: {
            showOn: ['profile'],
            type: 'password',
            label: 'Confirm Password'
          },
          hideExpression: "!model.newPassword"
          // validators:{
          //   confirmation: '$viewValue === model.newPassword'
          // }
        },
        {
          key: 'div2',
          type: 'divider',
          templateOptions: {
            showOn: ['signup','profile','upgrade']
          }
        },
        {
          key: 'intro',
          type: 'description',
          templateOptions: {
            showOn: ['signup', 'upgrade'],
            label: '',
            text: 'Providing us with your name and email grants you access to Lite Membership which includes a selection of resources on disciple-making. If you have read The Vine Project and you’re moving towards assembling a team (or you’re already part of a team), then please check the box below to access Full Membership which includes the Team Manual, Real World Stories, Common Roadblocks, Templates, and access to a supportive community of ministry leaders committed to developing disciple-making culture.'
          }
        },
        {
          key: 'fullMember',
          type: 'checkbox',
          templateOptions: {
            showOn: ['signup', 'profile', 'upgrade'],
            label: 'Full Membership: I plan to start The Vine Project with my Church/Organisation'
          },
          expressionProperties: {
            'templateOptions.disabled': 'model.type==="full"'
          }
        },
        {
          key: 'div3',
          type: 'divider',
          templateOptions: {
            showOn: ['signup','profile','upgrade'],
            label: 'Full Membership Options'
          },
          hideExpression: "!model.fullMember"
        },
        {
          key: "timeframe",
          type: "select",
          templateOptions: {
            showOn: ['signup', 'upgrade'],
            label: "Estimated timeframe for starting The Vine Project",
            valueProp: "option",
            labelProp: "label",
            options: timeframeOptions,
            required: true
          },
          hideExpression: "!model.fullMember"
        },
        {
          key: "title",
          type: "select",
          templateOptions: {
            showOn: ['signup', 'profile', 'upgrade'],
            label: "Title",
            valueProp: "option",
            labelProp: "option",
            options: titleOptions,
            required: true
          },
          hideExpression: "!model.fullMember"
        },
        {
          key: "role",
          type: "select",
          templateOptions: {
            showOn: ['signup', 'profile', 'upgrade'],
            label: "Ministry Role",
            valueProp: "option",
            labelProp: "option",
            options: roleOptions,
            required: true
          },
          hideExpression: "!model.fullMember"
        },
        {
          key: 'organisationName',
          type: 'input',
          templateOptions: {
            showOn: ['signup', 'profile', 'upgrade'],
            type: 'text',
            label: 'Church/Organisation Name',
            required: true
          },
          hideExpression: "!model.fullMember"
        },
        {
          key: "denomination",
          type: "select",
          templateOptions: {
            showOn: ['signup', 'profile', 'upgrade'],
            label: "Denomination",
            valueProp: "option",
            labelProp: "option",
            options: denominationOptions,
            required: true
          },
          hideExpression: "!model.fullMember"
        },
        {
          key: 'phone',
          type: 'input',
          templateOptions: {
            showOn: ['signup', 'profile', 'upgrade'],
            type: 'text',
            label: 'Phone'
          },
          hideExpression: "!model.fullMember"
        },
        {
          key: 'mobile',
          type: 'input',
          templateOptions: {
            showOn: ['signup', 'profile', 'upgrade'],
            type: 'text',
            label: 'Mobile/Cell'
          },
          hideExpression: "!model.fullMember"
        },
        {
          key: 'address',
          type: 'input',
          templateOptions: {
            showOn: ['signup', 'profile', 'upgrade'],
            type: 'text',
            label: 'Address'
          },
          hideExpression: "!model.fullMember"
        },
        {
          key: "country",
          type: "select",
          templateOptions: {
            showOn: ['signup', 'profile', 'upgrade'],
            label: "Country",
            valueProp: "option",
            labelProp: "label",
            options: countryOptions,
            required: true
          },
          hideExpression: "!model.fullMember",
          watcher: {
            listener: function(field, newValue) {
              vm.user.user.statesFieldHasOptions = setStates(newValue);
            }
          }
        },
        {
          key: "state",
          type: "select",
          templateOptions: {
            showOn: ['signup', 'profile', 'upgrade'],
            label: "State/County",
            valueProp: "option",
            labelProp: "label",
            options: stateOptions,
            required: true
          },
          hideExpression: "model.statesFieldHasOptions != true"
        },
        {
          key: 'state',
          type: 'input',
          templateOptions: {
            showOn: ['signup', 'profile', 'upgrade'],
            type: 'text',
            label: 'State/County',
            required: false
          },
          hideExpression: "model.statesFieldHasOptions == true || !model.fullMember"
        },
        {
          key: 'suburb',
          type: 'input',
          templateOptions: {
            showOn: ['signup', 'profile', 'upgrade'],
            type: 'text',
            label: 'Suburb',
            required: true
          },
          hideExpression: "!model.fullMember"
        },
        {
          key: 'postcode',
          type: 'input',
          templateOptions: {
            showOn: ['signup', 'profile', 'upgrade'],
            type: 'text',
            label: 'Postcode / Zipcode',
            required: true
          },
          hideExpression: "!model.fullMember"
        },
        {
          key: 'div4',
          type: 'divider',
          templateOptions: {
            showOn: ['signup','profile','upgrade'],
            label: 'Subscription Options'
          }
        },
        {
          key: 'shareEmail',
          type: 'checkbox',
          templateOptions: {
            showOn: ['signup', 'profile', 'upgrade'],
            label: 'I\'m happy for other Vine Project members to connect with me'
          },
          hideExpression: "!model.fullMember"
        },
        {
          key: 'shareNote',
          type: 'description',
          templateOptions: {
            showOn: ['signup', 'profile', 'upgrade'],
            label: '',
            text: "I\'m ok for staff to send a registered member my name and email address if they would like to discuss 'The Vine Project' with someone nearby."
          },
          hideExpression: "!model.fullMember"
        },
        {
          key: 'div5',
          type: 'divider',
          templateOptions: {
            showOn: ['signup','profile','upgrade']
          },
          hideExpression: "!model.fullMember"
        },
        {
          key: 'subscribeGotherefor',
          type: 'checkbox',
          templateOptions: {
            showOn: ['signup', 'profile', 'upgrade'],
            label: 'Subscribe to the GoThereFor newsletter'
          }
        },
        {
          key: 'subscribeNote',
          type: 'description',
          templateOptions: {
            showOn: ['signup', 'profile', 'upgrade'],
            label: '',
            text: "GoThereFor.com is an online library with resources, ideas and encouragement for fulfilling Christ’s commission to make disciples of all peoples. Our publisher Matthias Media will send you the regular GoThereFor email to feed you with disciple‐making resources. Of course you can unsubscribe at any time, but we’re hopeful it will be of great benefit to you."
          }
        },
        {
          key: 'div5',
          type: 'divider',
          templateOptions: {
            showOn: ['signup','upgrade'],
            label: 'Any Additional Information'
          }
        },
        {
          key: 'notes',
          type: 'textarea',
          templateOptions: {
            showOn: ['signup', 'upgrade'],
            placeholder: "Any extra notes you'd like to leave for the staff",
            rows: 4
          }
        }
      ];

      vm.onSignupSubmit = function() {
        var promise;
        usSpinnerService.spin('submit-spinner');
        clearMessage();

        if( vm.formType === 'profile' ) {
          if( vm.user.user.newPassword_confirmation !== vm.user.user.newPassword ) {
            showMessage("Please ensure your passwords match", 'error');
            return false;
          }
          promise = updateUser();
        } else if( vm.formType === 'upgrade' ) {
          promise = updateUser();
        } else {
          if( vm.user.user.password_confirmation !== vm.user.user.password ) {
            showMessage("Please ensure your passwords match", 'error');
            return false;
          }
          promise = createUser();
        }

        promise.then( function() {
          showMessage('Your Profile has been updated','success');
          modalService.close();
          usSpinnerService.stop('submit-spinner');
          $state.go('home');
        }, function(response) {
          $log.error(response);
          var msg;
          if( response.response ) { //APFix - move error checking further up
            msg = response.response.data.message;
          } else {
            msg = response.data.message;
          }
          showMessage(msg,'error');
          usSpinnerService.stop('submit-spinner');
        });
      }

      function updateUser() {
        vm.user.user.use_method = 'PUT';
        $log.log(vm.user.user);
        return userService.save( vm.user.user );
      }

      function createUser() {
        return userService.registerNew( vm.user.user );
      }

      function showMessage(message, style) {
        vm.userClass = style==='error' ? 'alert-danger' : 'alert-success';
        vm.userMessage = message;

        $location.hash('modalMessage');
        $anchorScroll();
      }
      
      function clearMessage() {
        vm.userMessage = '';
      }
      /**
       * Select Which Fields get passed through to the form based on the formType
       * @return {arr}
       */
      function chooseFields() {
        vm.userFormButton = userFormOptions[vm.formType].submit;

        return userFields.filter(function (el) {
          return (el.templateOptions.showOn.indexOf( vm.formType ) !== -1);
        });
      }

      init();
    }
  }

})();

(function() {
  'use strict';

  angular
    .module('vinelib')
    .directive('vineFooter', vineFooter);

  /** @ngInject */
  function vineFooter() {
    var directive = {
      restrict: 'E',
      templateUrl: 'app/components/footer/footer.html',
      controller: FooterController,
      controllerAs: 'footerCtrl',
      bindToController: true
    };

    return directive;

    /** @ngInject */
    function FooterController() {
      var vm = this;

      vm.copyright = getCopyright();

      function getCopyright() {
        var yearStart = '2016';
        var year = new Date().getFullYear();

        return (year == yearStart) ? year : yearStart + ' - ' + year;
      }
    }
  }

})();
(function() {
  'use strict';

  angular
    .module('vinelib')
    .filter('shorten', shorten);

  /** @ngInject */
  function shorten() {

    return function (value, max, turnOff, tail) {
        if (!value) return '';

        if( turnOff )
          return value;

        var len = max ? max : 200;

        if( value.length < len )
          return value;
        
        tail = tail ? tail : '...';

        return value.substring(0,len)+tail;
    };
  }

})();

(function() {
  'use strict';

  angular
    .module('vinelib')
    .directive('vgComments', vgComments);

  /** @ngInject */
  function vgComments() {
    var directive = {
      restrict: 'E',
      templateUrl: 'app/components/comments/comments.html',
      scope: {
          comments: '=',
          resource: '='
      },
      controller: CommentsController,
      controllerAs: 'vm',
      bindToController: true
    };

    return directive;

    /** @ngInject */
    function CommentsController(Comment, Resource, userService) {
      var vm = this;
      vm.newComment = {};
      vm.sendAnon = false;
      vm.currentUser = userService.currentUser;

      vm.submitComment = function() {
        vm.newComment.resource_id = vm.resource.id;
        Comment.post(vm.newComment)
          .then( function(data) {
            vm.comments = data;
            vm.resource.watching = true;
          });

        //reset
        vm.sendAnon = vm.newComment.anon;
        vm.newComment = { anon: vm.sendAnon };
        // $window.document.getElementById("vm.commentForm_input_comment_0").focus();
      };

      vm.deleteComment = function(comment) {
        comment = Comment.makeModel(comment);
        var index = vm.comments.indexOf(comment);

        comment.remove()
          .then( function() {
            vm.comments.splice( index, 1);
          });
      }

      vm.getWatchingText = function() {
        return vm.resource.watching ? 'Stop Watching' : 'Watch this resource';
      };

      vm.toggleWatch = function() {
        if( vm.resource.watching ) {
          Resource.unwatch( vm.resource.slug )
            .then( function() {
              vm.resource.watching = false;
            });
        } else {
          Resource.watch( vm.resource.slug )
            .then( function() {
              vm.resource.watching = true;
            });
        }
      };

      vm.commentFields = [
        {
          key: 'comment',
          type: 'textarea',
          templateOptions: {
            placeholder: 'Join in the discussion...',
            required: true,
            rows: 4
          }
        },
        {
          key: 'anon',
          type: 'checkbox',
          className: 'width-50',
          templateOptions: {
            label: 'Send Anonymously'
          }
        }
      ];
    }
  }

})();

(function() {
  'use strict';

  angular
    .module('vinelib')
    .directive('vgCategoryGrid', vgCategoryGrid);

  /** @ngInject */
  function vgCategoryGrid() {
    var directive = {
      restrict: 'E',
      scope: {
          categorySlug: '@categorySlug',
          templateType: '@templateType'
      },
      template: '<ng-include src="vm.getTemplateUrl()"/>',
      controller: CategoryGridController,
      controllerAs: 'vm',
      bindToController: true
    };

    return directive;

    /** @ngInject */
    function CategoryGridController($scope, categoryService) {
      var vm = this;
      vm.categoryList;
      vm.currentCategory;
      vm.parent = {empty: true};

      initialiseData();

      function initialiseData() {
        vm.categoryList = categoryService.menuCategories;
        vm.currentCategory = categoryService.currentCategory;

        $scope.$watch('categorySlug', function(){
            categoryService.setCurrentCategoryBySlug( vm.categorySlug );
        }, true);
      }
      
      //Choose Template (list, grid)
      vm.getTemplateUrl = function() {
        if( vm.templateType === 'list' )
          return 'app/components/categoryGrid/categoryList.html';

        return 'app/components/categoryGrid/categoryGrid.html';
      }
    }
  }

})();


(function () {
  'use strict';

  angular
    .module('vinelib')
    .factory('Category', Category);

  // Category.$inject = ['Restangular'];

  /** @ngInject */
  function Category(Restangular) {
    
    var path = 'categories';
    var _service = Restangular.all(path);

    _service.updateOrder = function( data ) {
      return Restangular.all( path )
        .customPOST( {order: data}, 'updateOrder', undefined);
    };

    _service.makeModel = function( data ) {
      return Restangular.restangularizeElement(null, data, path);
    }

    // _service.getChildren = function(categorySlug) {
    //   return Restangular.all( 'categories/' + categorySlug + '/categories', {include: 'children'}).getList().$object;
    // };

    // _service.getToplevel = function() {
    //   return _service.getList({toplevel: true}).$object;
    // };

    return _service;
  }

  angular
    .module('vinelib')
    .service('categoryService', categoryService);

  /** @ngInject */
  function categoryService(Category, Restangular, $filter) {
    var self = this;
    self.menuCategories = [];
    self.currentCategory = [];
    var currentSlug = null;

    init();

    self.setCurrentCategoryBySlug = function(slug) {
      currentSlug = slug;

      if( self.menuCategories.length > 0 ) {
        refreshCurrentCategory();
      }
    }

    function refreshCurrentCategory() {
      var currentCategory = $filter('filter')(self.menuCategories, {slug: currentSlug}, true)[0];
      Restangular.copy(currentCategory, self.currentCategory);
    }

    function refreshCategories() {
      Category.getList({include: "children",toplevel: true, visibleonly: true}).then( function(data) {
        for (var i = 0; i < data.length; i++) {
          data[i].children = data[i].children.data; //promote the children.data property
        }
        Restangular.copy(data, self.menuCategories);
        if( currentSlug ) {
          refreshCurrentCategory();
        }
      });
    }

    function init() {
      if( self.menuCategories.length === 0 ) {
        refreshCategories();
      }
    }

  }

})();
(function () {
  'use strict';

  //User Model
  angular
    .module('vinelib')
    .factory('User', User);

  User.$inject = ['Restangular', 'configService', '$http'];
  /** @ngInject */
  function User(Restangular, configService, $http) {
    //APFix: check here to see how to do the user model http://blog.revolunet.com/blog/2014/02/14/angularjs-services-inheritance/
    var urlPart = 'users';
    var _service = Restangular.all( urlPart );

    return {
      getAuthenticated: function() {
        return _service.get('current');
      },
      registerNew: function(data) {
        var url = configService.getLocalConfig( 'apiLocation' );
        return $http.post( url + '/' + urlPart,data,{});
      },
      sendPasswordEmail: function(data) {
        var url = configService.getLocalConfig( 'apiLocation' );
        return $http.post( url + '/auth/password/email' ,data,{});
      },
      resetPassword: function(data) {
        var url = configService.getLocalConfig( 'apiLocation' );
        return $http.post( url + '/auth/password/reset' ,data,{});
      },
      getNew: function() {
        return _service.one(urlPart);
      },
      save: function(data) {
        return _service.customPUT(data,data.id);
      }
    }
  }

  angular
    .module('vinelib')
    .service('userService', userService);

  userService.$inject = ['$q', '$state', '$log', '$http', 'configService', 'jwtHelper', 'User', 'Restangular'];
  /** @ngInject */
  function userService($q, $state, $log, $http, configService, jwtHelper, User, Restangular) {
    var self = this;
    var token = null;
    var observerCallbacks = [];
    self.currentUser = {
      loggedIn: false,
      user: {}
    };

    init();

    self.canAccess = canAccess;

    //register an observer so we get updated on the login state
    self.registerObserverCallback = function(callback){
      observerCallbacks.push(callback);
    }

    self.registerNew = function(data) {
      var deferred = $q.defer();
      User.registerNew(data)
        .then(function successCallback(response) {
          if( response.status !== 200 ) {
            deferred.reject({success: false, response: response});
          } else {
            setCurrentUser( response.data.meta.token, response.data.data );
            deferred.resolve({success: true, response: response});
          }
        }, function errorCallback(response) {
          deferred.reject({success: false, response: response});
        }
      );
      return deferred.promise;
    }

    self.sendPasswordEmail = function(data) {
      return User.sendPasswordEmail(data);
    }

    self.resetPassword = function(data) {
      return User.resetPassword(data);
    }

    self.save = function(data){
      var deferred = $q.defer();
      User.save(data)
        .then( function(data) {
          updateCurrentUser(data);
          deferred.resolve(data);
        });

      return deferred.promise;
    }

    self.login = function(data) {
      var deferred = $q.defer();
      Restangular.all('login').post(data)
        .then( function(response) {
          $log.log(response);
          if( response.hasOwnProperty('status') && response.status !==200 ) {
            clearCurrentUser();
            $log.error(response);
            deferred.reject({success: false, message: translateErrorMessage(response)});
          } else {
            setCurrentUser(response.token,response);
            deferred.resolve({success: true, message: 'Successfully logged in to the Library'});
          }
        }, function(response) {
          clearCurrentUser();
          $log.error(response);
          deferred.reject({success: false, message: translateErrorMessage(response)});
        }
      );
      return deferred.promise;
    }

    function init() {
      checkForLocalToken();
    }

    function canAccess(area) {
      var roleId = Number(self.currentUser.user.roleId);
      if( area === 'admin' ) {
        return ( roleId === 1 || roleId === 2 );
      }
    }

    function translateErrorMessage(response) {
      if( ! response.data.error )
        return null;

      var messages = {
        "invalid_credentials": "Email address or Password was incorrect"
      };

      return ( messages[ response.data.error ] ) ? messages[ response.data.error ] : '';

    }

    self.logout = function() {
      clearCurrentUser();
      $state.go('home');
    }

    self.getToken = function() {
      return token;
    }

    function setToken(newtoken) {
      if(newtoken===null || newtoken==='null' || newtoken==='undefined') {
        localStorage.removeItem("JWT");
      } else {
        localStorage.setItem('JWT', newtoken);
      }
      token = newtoken;
    }

    /**
     * Update any observers when the login state has changed
     */
    function notifyObservers(){
      angular.forEach(observerCallbacks, function(callback){
        callback();
      });
    }

    function clearCurrentUser() {
      setCurrentUser(null,{});
    }

    function setCurrentUser(token,data) {
      if( token === null || token === 'null') {
        self.currentUser.loggedIn = false;
      } else {
        self.currentUser.loggedIn = true;
      }
      setToken(token);
      Restangular.copy(data, self.currentUser.user);
      self.currentUser.isAdmin = canAccess('admin');
      notifyObservers();
    }

    function updateCurrentUser(data) {
      Restangular.copy(data, self.currentUser.user);
      self.currentUser.isAdmin = canAccess('admin');
      notifyObservers();
    }

    //grab the token from localStorage on startup
    function checkForLocalToken() {
      var _token = localStorage.getItem('JWT');
      if( _token === null || _token === 'null' || _token === 'undefined' ) {
        return false;
      }

      if( jwtHelper.isTokenExpired(_token) ) {
        return false;
      }

      User.getAuthenticated().then(function(data){
        setCurrentUser( _token, data );
      });
    }
  }

})();

(function () {
  'use strict';

  angular
    .module('vinelib')
    .factory('Resource', Resource);

  /** @ngInject */
  function Resource(Restangular) {
    var path = 'resources';

    var service = Restangular.service(path);

    service.watch = function( resourceSlug ) {
      return Restangular.one(path, resourceSlug).customOperation('post', 'watch');
    }

    service.unwatch = function( resourceSlug ) {
      return Restangular.one(path, resourceSlug).customOperation('post', 'unwatch');
    }

    service.edit = function( resourceSlug ) {
      return Restangular.one(path, resourceSlug).customOperation('get', 'edit');
    }
    
    service.getNew = function( ) {
      return Restangular.one(path).customOperation('get', 'getnew');
    }
    
    service.makeModel = function( data ) {
      return Restangular.restangularizeElement(null, data, path);
    }

    return service;

  }

  angular
    .module('vinelib')
    .service('resourceService', resourceService);

  /** @ngInject */
  function resourceService(Resource, Restangular, userService) {
    var self = this;
    self.data = { featuredResources: [], searchResults: [], searchTerm: '', searching: false };

    //get Featured Articles and cache them
    function getFeatured() {
      var params = {
        category: 'featured',
        pagination: 5
      }

      return Resource.getList(params).then(function(data){
        Restangular.copy(data, self.data.featuredResources);
      });
    }

    self.search = function(searchTerm) {
      self.data.searchTerm = searchTerm;
      self.data.searching = true;

      var params = {
        search: self.data.searchTerm
      }

      self.data.searchResults.length = 0;

      return Resource.getList(params).then(function(data){
        self.data.searching = false;
        self.data.searchTerm = null;
        Restangular.copy(data, self.data.searchResults);
      });
    }

    function init() {
      getFeatured();
      userService.registerObserverCallback(getFeatured);
    }

    init();
  }

})();

(function () {
  'use strict';

  angular
    .module('vinelib')
    .factory('Media', Media);

  /** @ngInject */
  function Media(Restangular) {
    var path = 'media';

    var service = Restangular.all(path);
    
    //Upload a file alond with the model data
    //Not sure why I can't use this as a function on the model, but it didn't work. need to pass the model into the function - http://doblydev.blogspot.de/2014/06/angularjs-adding-new-objects-with.html
    service.uploadFile = function( model, file ) {
      var formData = new FormData();
      formData.append('fileUpload', file );
      formData.append('title', model.title);
      formData.append('id', model.id);
      formData.append('media_type', model.media_type);
      formData.append('resource_id', model.resource_id);

      if( model.id )
        formData.append('use_method', 'PUT');

      return Restangular.all( path )
        .withHttpConfig({transformRequest: angular.identity})
        .customPOST(formData, model.id, undefined, {'Content-Type': undefined});
    }

    return service;

  }

})();

(function () {
  'use strict';

  angular
    .module('vinelib')
    .factory('Comment', Comment);

  /** @ngInject */
  function Comment(Restangular) {
    var path = 'comments';
    var service = Restangular.service(path);

    service.makeModel = function( data ) {
      return Restangular.restangularizeElement(null, data, path);
    }

    return service;

  }

  // angular
  //   .module('vinelib')
  //   .service('commentService', commentService);

  /** @ngInject */
  // function commentService(Comment, Restangular) {
  //   var self = this;

  // }

})();
// (function() {
//   'use strict';

//   angular
//     .module('vinelib')
//     .controller('MainController', MainController);

//   /** @ngInject */
//   function MainController($stateParams, Resource) {
//     var vm = this;

//     vm.categorySlug = $stateParams.categorySlug ? $stateParams.categorySlug : 'phaseresources';

//     loadResources();

//     function loadResources() {
//       //Setup query parameters
//       var params = {
//         filter: 'featured',
//         pagination: 5
//       }

//       //Get data via model
//       Resource.getList(params).then(function(data){
//         vm.resources = data;
//       });        
//     }

//   }
// })();

(function() {
  'use strict';

  angular
    .module('vinelib')
    .run(runBlock);

  /** @ngInject */
  function runBlock($rootScope, $state, userService, configService, Restangular, usSpinnerService, $log) {

    registerEventHandler();

    /**
     * Register event handler for ui-router state change
     * See https://github.com/angular-ui/ui-router/wiki for more information.
     */
    function registerEventHandler() {

      var unlisten = $rootScope.$on('$stateChangeStart', function (event, toState) {
        //Don't bother checking for Admin Access (debugging use only)
        if( ! configService.getLocalConfig( 'checkFence' ) )
          return true;

        if(toState.name && toState.name.match(/^admin\./)){
          if( ! userService.canAccess('admin') ) {
            $log.debug('Access not allowed. Redirecting to home page');
            event.preventDefault();
            return $state.go('home');
          }
        }
      });

      $rootScope.$on('$destroy', unlisten);

      //Start loading spinner on request
      Restangular.addRequestInterceptor(function(element) {
          usSpinnerService.spin('main-spinner');
          return element;
      });

      //Stop loading spinner after request
      Restangular.addResponseInterceptor(function(element) {
          usSpinnerService.stop('main-spinner');
          return element;
      });


      //Set Default Error Handlers
      Restangular.setErrorInterceptor(function(response) {
        if(response.status === 403) {
        //   resourceService.getFeatured(); APFix: Make Provider so we can refresh featured items from here
          $state.go('home');
          return false;
        }

        return true; // error not handled
      });
    }
  }

})();
(function() {
  'use strict';

  angular
    .module('vinelib')
    .config(routerConfig);

  /** @ngInject */
  function routerConfig($stateProvider, $urlRouterProvider) {
    $stateProvider.state('home', {
      url: '/:categorySlug',
      templateUrl: 'app/pages/home/home.html',
      controller: 'HomeController',
      controllerAs: 'home'
    });

    $stateProvider.state('category', {
      url: '/categories/:categorySlug',
      templateUrl: 'app/pages/category/category.html',
      controller: 'CategoryController',
      controllerAs: 'category'
    });

    $stateProvider.state('resource', {
      url: '/resources/:resourceSlug',
      templateUrl: 'app/pages/resource/resource.html',
      controller: 'ResourceController',
      controllerAs: 'resource',
      resolve: {
        resourceModel: function($stateParams, Resource) {
          return Resource.one( $stateParams.resourceSlug ).get();
        }
      }

    });

    // Administration area
    $stateProvider.state('admin', {
      abstract: true,
      template: "<ui-view/>"
    })

    $stateProvider.state('admin.resources', {
      url: '/admin/resources',
      templateUrl: 'app/pages/adminresources/adminresources.html',
      controller: 'AdminresourcesController',
      controllerAs: 'adminresourcesCtrl'
    });

    $stateProvider.state('admin.editresource', {
      url: '/resources/:resourceSlug/edit',
      templateUrl: 'app/pages/editresource/editresource.html',
      controller: 'EditresourceController',
      controllerAs: 'editresourceCtrl',
      resolve: {
        resource: function($stateParams, Resource) {
          return Resource.edit( $stateParams.resourceSlug );
        }
      }
    });

    $stateProvider.state('admin.editcategory', {
      url: '/admin/categories',
      templateUrl: 'app/pages/editcategory/editcategory.html',
      controller: 'EditcategoryController',
      controllerAs: 'editcategoryCtrl'
    });

    $stateProvider.state('admin.newresource', {
      url: '/admin/newresource',
      templateUrl: 'app/pages/editresource/editresource.html',
      controller: 'EditresourceController',
      controllerAs: 'editresourceCtrl',
      resolve: {
        resource: function($stateParams, Resource) {
          return Resource.edit( 'new' );
        }
      }
    });

    $stateProvider.state('admin.media', {
      url: '/admin/media',
      templateUrl: 'app/pages/media/media.html',
      controller: 'MediaController',
      controllerAs: 'mediaCtrl'
    });

    $stateProvider.state('profile', {
      url: '/settings/profile',
      templateUrl: 'app/pages/profile/profile.html',
      controller: 'ProfileController',
      controllerAs: 'profileCtrl',
      params: {formtype: 'profile'}
    });

    $stateProvider.state('join', {
      abstract: true,
      template: "<ui-view/>"
    });

    $stateProvider.state('join.info', {
      url: '/join/info',
      templateUrl: 'app/pages/membership/membership.html',
      controller: 'MembershipController',
      controllerAs: 'membershipCtrl',
      params: {page: 'info'}
    });

    $stateProvider.state('join.lite', {
      url: '/join/lite',
      templateUrl: 'app/pages/membership/membership.html',
      controller: 'MembershipController',
      controllerAs: 'membershipCtrl',
      params: {formtype: 'signup', page: 'form'}
    });

    $stateProvider.state('join.full', {
      url: '/join/full',
      templateUrl: 'app/pages/membership/membership.html',
      controller: 'MembershipController',
      controllerAs: 'membershipCtrl',
      params: {formtype: 'full', page: 'form'}
    });

    $stateProvider.state('search', {
      url: '/library/search',
      templateUrl: 'app/pages/search/search.html',
      controller: 'SearchController',
      controllerAs: 'searchCtrl',
      params: {searchTerm: null}
    });

    $stateProvider.state('password-reset', {
      url: '/password/reset',
      templateUrl: 'app/pages/password/reset.html',
      controller: 'PasswordController',
      controllerAs: 'passCtrl'
    });

    $stateProvider.state('password-change', {
      url: '/password/change/:email/:token',
      templateUrl: 'app/pages/password/change.html',
      controller: 'PasswordController',
      controllerAs: 'passCtrl'
    });

    $urlRouterProvider.otherwise('/');
  }

})();

/* global moment:false */
(function() {
  'use strict';

  angular
    .module('vinelib')
    .constant('moment', moment);

})();

/* globals $, localConfig */

(function() {
  'use strict';

    angular
    .module('vinelib')
    .service('configService', configService);

  /** @ngInject */
  function configService() {
    var alreadyRetrievedLocal = false;
    var vineConfig = {
      "debug": false,
      "appName": "The Vine Project API",
      "apiLocation": "http://api.thevineproject.com",
      "checkFence": true //used for debugging - doesn't redirect if the user doesn't have admin access
    };

    this.getLocalConfig = function (key) {
        if( ! alreadyRetrievedLocal ) {
          if (typeof localConfig !== 'undefined')
            vineConfig = $.extend( vineConfig, localConfig );

          alreadyRetrievedLocal = true;
        }

        if( typeof vineConfig[key] === 'undefined' )
          return false;

        return vineConfig[key];
    };

  }

  angular
    .module('vinelib')
    .config(config);

  /** @ngInject */
  function config($logProvider, RestangularProvider, $httpProvider, jwtInterceptorProvider, configServiceProvider) {
    // Enable log
    $logProvider.debugEnabled(true);

    //Get Config Service
    var _config = configServiceProvider.$get();

    //###Setup Restangular
    //Set the Base URL
    RestangularProvider.setBaseUrl( _config.getLocalConfig( 'apiLocation' ) );
    
    //Modify the response
    RestangularProvider.addResponseInterceptor(function(data) {
      var extractedData;
      
      if( data.hasOwnProperty("data") ) {
        extractedData = data.data;
      } else {
        extractedData = data;
      }

      if( data.hasOwnProperty("meta") ) {
        angular.extend( extractedData, data.meta );
      }

      return extractedData;
    });

    // Send Token through on each API request
    jwtInterceptorProvider.tokenGetter = function() {
      return localStorage.getItem('JWT');
    };

    $httpProvider.interceptors.push('jwtInterceptor');

    //Disable the spinner from the loading bar (it clashes with the logo)
    // cfpLoadingBarProvider.includeSpinner = false;

  }

})();
angular.module("vinelib").run(["$templateCache", function($templateCache) {$templateCache.put("app/components/categoryGrid/categoryList.html","<div class=row><h2>{{ vm.currentCategory.name }}</h2><div class=\"category-item row col-xs-12\" ng-repeat=\"category in vm.currentCategory.children\"><a ui-sref=\"category({ categorySlug: category.slug })\" class=category-item-inner><h4>{{ category.name }}&nbsp;<small>({{ category.resources_count }})</small></h4><span><i class=\"fa fa-chevron-right\" aria-hidden=true></i></span></a></div></div>");
$templateCache.put("app/components/comments/comments.html","<div class=comments-wrap><h4>Discussion about this article <a class=\"watch-button btn btn-small btn-default pull-right\" ng-click=vm.toggleWatch()>{{ vm.getWatchingText() }}</a></h4><form class=comment-form ng-submit=vm.submitComment() name=vm.commentForm novalidate><formly-form model=vm.newComment fields=vm.commentFields form=vm.commentForm><div class=\"text-right pull-up\"><button type=submit class=\"btn btn-primary\" ng-disabled=vm.commentForm.$invalid>Send</button></div></formly-form></form><hr><div class=comment-item ng-repeat=\"comment in vm.comments\" ng-class=\"{own : comment.currentAuthor}\"><div class=bubble ng-click=\"comment.showAll=!comment.showAll\">{{ comment.comment | shorten : 200 : comment.showAll }}</div><div class=meta>{{ comment.author }}, {{ comment.published }}&nbsp;<i ng-show=vm.currentUser.isAdmin ng-click=vm.deleteComment(comment) class=\"fa fa-trash\" aria-hidden=true></i></div></div><div ng-show=!vm.comments.length>No comments have been made on this article yet</div></div>");
$templateCache.put("app/components/footer/footer.html","<footer><div class=\"bg-col-dark inverse row footer-top\"><div class=container><div class=pull><ul><!-- <li><a href=\"https://vinegrowers.com/\">Vinegrowers</a></li> --><li><a href=https://thevineproject.com/ >The Vine Project</a></li><li><a href=https://thevineproject.com/privacy/ >Privacy</a></li><li><a href=https://thevineproject.com/donate/ >Donate</a></li><li><a href=https://thevineproject.com/contact/ >Contact</a></li></ul></div></div></div><div class=\"bg-col-dark inverse row footer-bottom\"><div class=container><div class=pull><p>&copy; {{footerCtrl.copyright}} <a href=https://vinegrowers.com/ >Vinegrowers Ltd.</a> | Developed by <a target=_blank href=http://cubesystems.com.au>Cube Systems</a> | Design by <a target=_blank href=http://elevatecreative.com.au>Elevate Creative</a>. | v1.0.6</p></div></div></div></footer>");
$templateCache.put("app/components/formSignup/formSignup.html","<div class=text-center ng-hide=vm.user.loggedIn><a class=small ng-click=vm.openLogin()>Already Registered? Login</a><br>&nbsp;<br></div><div id=modalMessage ng-show=vm.userMessage class=alert ng-class=vm.userClass>{{ vm.userMessage }}</div><form class=join-form ng-submit=vm.onSignupSubmit() name=vm.signupForm novalidate><formly-form model=vm.user.user fields=vm.userFields form=vm.signupForm><div class=text-right style=position:relative><button type=submit class=\"btn btn-lg btn-primary\" ng-disabled=vm.signupForm.$invalid>{{vm.userFormButton}}</button> <span us-spinner=\"{radius:5, length:10, width:5, left:\'70%\'}\" spinner-key=submit-spinner></span></div></formly-form></form>");
$templateCache.put("app/components/forms/description.html","<div class=form-group><div>{{options.templateOptions.text}}</div></div>");
$templateCache.put("app/components/forms/divider.html","<h4 ng-if=to.label>{{options.templateOptions.label}}</h4><hr>");
$templateCache.put("app/components/forms/editor.html","<div class=form-group><div><text-angular ng-model=model[options.key]></text-angular></div></div>");
$templateCache.put("app/components/forms/readonly.html","<label class=control-label ng-if=to.label>{{options.templateOptions.label}}:&nbsp;</label>{{model[options.key]}}");
$templateCache.put("app/components/modal/modal.html","<div class=modal-header><h3>{{modalOptions.headerText}}</h3></div><div class=modal-body><p>{{modalOptions.bodyText}}</p><div id=tpl-content ng-include src=modalOptions.bodyTemplate></div></div><div class=modal-footer ng-show=modalOptions.actionButtonText><button type=button class=btn data-ng-click=modalOptions.close()>{{modalOptions.closeButtonText}}</button> <button class=\"btn btn-primary\" data-ng-click=\"modalOptions.ok( modalOptions.user );\">{{modalOptions.actionButtonText}}</button></div>");
$templateCache.put("app/components/navbar/menu.html","<div class=alt-menu-container><div class=\"hidden-md hidden-lg\"><a class=\"btn btn-navbar pull-right\" ng-click=vm.closeMenu()><span class=\"fa fa-bars\"></span></a><h4>The Vine Project</h4><a ui-sref=\"resource({resourceSlug: \'team-manual\'})\" class=\"btn btn-info btn-fullsize\" ng-show=vm.user.user.fullMember ng-click=vm.closeMenu()><i class=\"fa fa-file-text-o\" aria-hidden=true></i> Download Team Manual</a><ul class=alt-menu><li ng-click=\"vm.toggleMenuItem(\'user\')\">User <i class=\"fa fa-plus\" aria-hidden=true></i><ul uib-collapse=\"vm.currentMenuOpen !== \'user\'\"><li ng-hide=vm.user.loggedIn><a ng-click=vm.openLogin()>Login</a></li><li ng-show=vm.user.loggedIn><a ng-click=vm.closeMenu() ui-sref=profile )>Profile</a></li><li ng-show=vm.user.loggedIn><a ng-click=vm.logoutUser() )>Logout {{vm.user.user.firstname}}</a></li></ul></li><li ng-show=vm.user.isAdmin ng-click=\"vm.toggleMenuItem(\'admin\')\">Admin <i class=\"fa fa-plus\" aria-hidden=true></i><ul uib-collapse=\"vm.currentMenuOpen !== \'admin\'\"><li><a ng-click=vm.closeMenu() ui-sref=admin.media )>Media</a></li><li><a ng-click=vm.closeMenu() ui-sref=admin.editcategory )>Categories</a></li><li><a ng-click=vm.closeMenu() ui-sref=admin.resources )>Resources</a></li></ul></li><li ng-click=\"vm.toggleMenuItem(\'search\')\">Search <i class=\"fa fa-plus\" aria-hidden=true></i></li><li uib-collapse=\"vm.currentMenuOpen !== \'search\'\"><form class=search-box ng-submit=vm.performSearch() name=vm.loginForm novalidate><input class=form-control ng-model=vm.searchTerm name=searchTerm placeholder=Search type=text aria-invalid=false></form></li></ul></div><h4>Resources</h4><ul class=alt-menu><li ng-repeat=\"category in vm.categories\" ng-click=vm.toggleMenuItem(category.slug) class=alt-menu-category>{{ category.name }} <i class=\"fa fa-plus\" aria-hidden=true></i><ul uib-collapse=\"vm.currentMenuOpen !== category.slug\"><li ng-repeat=\"child in category.children\"><a ui-sref=\"category({ categorySlug: child.slug })\" ng-click=vm.closeMenu()>{{ child.name }}</a></li></ul></li></ul><h4>Community</h4><ul class=alt-menu><!-- <li><a href=\"#\">My Comments</a></li> --><li><a href=https://www.facebook.com/groups/thevineproject/ target=_blank ng-click=vm.closeMenu()>Members Facebook</a></li><li><a href=https://www.facebook.com/thevineproject.org/ target=_blank ng-click=vm.closeMenu()>TVP Facebook Page</a></li><li><a href=https://thevineproject.com/contact/ target=_blank ng-click=vm.closeMenu()>Contact TVP Team</a></li></ul><h4>About</h4><ul class=alt-menu><li><a href=https://thevineproject.com/ target=_blank ng-click=vm.closeMenu()>The Vine Project</a></li><li><a href=http://www.vinegrowers.com/ target=_blank ng-click=vm.closeMenu()>Vinegrowers</a></li><li><a href=https://thevineproject.com/donate/ target=_blank ng-click=vm.closeMenu()>Donate</a></li><li><a href=https://thevineproject.com/privacy/ target=_blank ng-click=vm.closeMenu()>Privacy</a></li></ul></div>");
$templateCache.put("app/components/navbar/navbar.html","<nav class=\"navbar row navbar-fixed-top\"><div class=\"navbar-inner bg\"><div class=container-fluid><a class=\"btn btn-navbar\" ng-click=\"vm.openMenu(\'top\',true)\"><span class=\"fa fa-bars\"></span> </a><a ui-sref=home() class=\"navbar-brand brand-logo\"><img src=assets/images/vine-logo.png> </a><a ui-sref=home() class=\"navbar-brand brand-title\">Resource Library</a><div class=nav-collapse><ul class=\"nav navbar-nav pull-right\" id=navbar-links><li class=nav-item ui-sref-active=active><a ui-sref=\"home({categorySlug: \'phaseresources\'})\">Phase Resources</a></li><li class=nav-item ui-sref-active=active><a ui-sref=\"home({categorySlug: \'general\'})\">General Resources</a></li><li class=nav-item><a class=\"btn btn-inverse\" ng-click=vm.openLogin() ng-hide=vm.user.loggedIn><i class=\"fa fa-user\" aria-hidden=true></i> Login</a></li><li class=nav-item uib-dropdown on-toggle=toggled(open)><a href id=user-dropdown ng-show=vm.user.loggedIn uib-dropdown-toggle><i class=\"fa fa-user\" aria-hidden=true></i></a><ul class=dropdown-menu uib-dropdown-menu><li><a ui-sref=profile ng-show=vm.user.loggedIn )>Profile</a></li><li><a ng-click=vm.logoutUser() ng-show=vm.user.loggedIn )>Logout {{vm.user.user.firstname}}</a></li></ul></li><li class=nav-item uib-dropdown on-toggle=toggled(open) ng-show=vm.user.isAdmin><a href id=settings-dropdown uib-dropdown-toggle><i class=\"fa fa-cogs\" aria-hidden=true></i></a><ul class=dropdown-menu uib-dropdown-menu><li><a ui-sref=admin.media )>Media</a></li><li><a ui-sref=admin.editcategory )>Categories</a></li><li><a ui-sref=admin.resources )>Resources</a></li></ul></li><li ng-if=vm.searchOpen class=nav-item><form class=search-box ng-submit=vm.performSearch() name=vm.loginForm novalidate><input class=form-control ng-model=vm.searchTerm name=searchTerm placeholder=Search type=text aria-invalid=false><!-- <button type=\"submit\" class=\"btn btn-lg btn-primary\" ng-disabled=\"!vm.searchTerm\">Go</button> --></form></li><li class=nav-item><a ng-click=\"vm.searchOpen= !vm.searchOpen\"><i class=\"fa fa-search\" aria-hidden=true></i></a></li><li class=nav-item><a ng-click=\"vm.openMenu(\'right\',true)\"><i class=\"fa fa-bars\" aria-hidden=true></i></a></li></ul></div></div></div></nav><script type=text/ng-template id=/loginTemplate.html><div class=\"text-center\" ng-hide=\"vm.user.loggedIn\">\n    <a class=\"small\" ui-sref=\"join.info\">Not Yet Registered? Sign Up</a><br>&nbsp;<br>\n  </div>\n  <form ng-submit=\"vm.submitLoginForm()\" name=\"vm.loginForm\" novalidate>\n    <div ng-show=\"vm.loginMessage\" class=\"alert\" ng-class=\"vm.loginClass\">{{ vm.loginMessage }}</div>\n    <formly-form model=\"vm.loginData\" fields=\"vm.loginFields\" form=\"vm.loginForm\">\n      <div class=\"row\">\n        <div class=\"col-sm-6\">\n          <a class=\"small\" ui-sref=\"password-reset()\">Forgot Password?</a>\n        </div>\n        <div class=\"col-sm-6 text-right\">\n          <button type=\"submit\" class=\"btn btn-lg btn-primary\" ng-disabled=\"vm.loginForm.$invalid\">Login</button>\n        </div>\n      </div>\n    </formly-form>\n  </form></script><script type=text/ng-template id=/formSignup.html><vg-form-signup form-type=\"signup\"></vg-form-signup></script><script type=text/ng-template id=/formUpgrade.html><vg-form-signup form-type=\"upgrade\"></vg-form-signup></script>");
$templateCache.put("app/components/resourceGrid/resourceGrid.html","<div class=\"resource-item col-sm-4\" ng-repeat=\"resource in vm.resources\"><a ng-click=vm.resourceAction($event,resource) ui-sref=\"resource({ resourceSlug: resource.slug })\" class=\"resource-inner vg-grid-item col-sm-12\"><div class=\"resource-img img-crop-narrow\"><img ng-src=\"{{ resource.feature }}\" alt=\"{{ resource.title }}\"></div><div class=details><div class=caption><h4>{{ resource.title }}</h4></div><span class=meta>{{ resource.author_name }} | {{ resource.published }} | {{ vm.capitalise( resource.type ) }}</span><div class=action-button><span class=btn ng-class=vm.buttonClass(resource)>{{ vm.getButtonText( resource ) }}</span></div></div></a></div>");
$templateCache.put("app/components/sidebar/sidebar.html","<div class=\"col-sm-12 well\"><h2>Related</h2></div>");
$templateCache.put("app/pages/adminresources/adminresources.html","<div class=\"admin-resources maincol col-md-12\"><h2>Resources <a class=\"btn btn-lg btn-default\" ui-sref=\"admin.editresource({resourceSlug: \'new\'})\">Add New Resource</a></h2><ul class=resource-list><li ng-repeat=\"resource in adminresourcesCtrl.resources\"><a ui-sref=\"admin.editresource({resourceSlug: resource.slug})\">{{ resource.title }} <small>({{resource.status}})</small></a></li></ul><div class=clearfix></div><ul uib-pagination items-per-page=adminresourcesCtrl.resources.pagination.per_page total-items=adminresourcesCtrl.resources.pagination.total ng-model=adminresourcesCtrl.pagination ng-change=adminresourcesCtrl.pageChanged()></ul></div>");
$templateCache.put("app/pages/category/category.html","<div class=\"maincol col-xs-12 col-lg-12\"><div class=page-summary><h2>{{ category.category.name }}</h2><p>{{ category.category.desc }}</p></div><h3>Resources</h3><vg-resource-grid resources=category.resources template-type=grid>Loading...</vg-resource-grid></div><!-- <vg-sidebar></vg-sidebar> -->");
$templateCache.put("app/pages/editcategory/editcategory.html","<div class=\"maincol col-md-8\"><h2>Edit Categories &nbsp; <small><button class=\"btn btn-primary\" ng-click=editcategoryCtrl.newCategory()>New Category</button> &nbsp; <button class=\"btn btn-warning\" ng-click=editcategoryCtrl.saveCategoryOrder() ng-show=editcategoryCtrl.orderChanged>Save Order</button></small></h2><div ng-show=editcategoryCtrl.categoryMessage class=alert ng-class=editcategoryCtrl.categoryClass>{{ editcategoryCtrl.categoryMessage }}</div><ul class=available-categories><li class=parent-category ng-repeat=\"category in editcategoryCtrl.categories\">{{ category.name }}<ul data-as-sortable=editcategoryCtrl.dragControlListeners data-ng-model=category.children><li class=child-category ng-repeat=\"child in category.children\" ng-class=\"{\'alert-danger\': child.highlight}\" data-as-sortable-item><i class=\"fa fa-bars\" aria-hidden=true data-as-sortable-item-handle></i>&nbsp; <span ng-click=editcategoryCtrl.editCategory(child,category)>{{ child.name }}</span>&nbsp;<small ng-show=child.resources_count>({{ child.resources_count }})</small><span ng-show=child.highlight>>>Drag me to the desired position then click \'Save Order\'</span></li></ul></li></ul></div><div class=\"subcol col-md-4\"><div class=well ng-if=\"editcategoryCtrl.categoryToEdit === null\"><strong>Select a category to make changes</strong></div><div class=\"edit-category well\" ng-if=\"editcategoryCtrl.categoryToEdit !== null\"><form class=category-form ng-submit=editcategoryCtrl.onEditSubmit() name=editcategoryCtrl.editcategoryForm novalidate><formly-form model=editcategoryCtrl.categoryToEdit fields=editcategoryCtrl.formFields form=editcategoryCtrl.editcategoryForm><div class=text-right><a class=\"btn btn-lg btn-default\" ng-click=editcategoryCtrl.removeCategory() ng-if=editcategoryCtrl.categoryToEdit.id>Remove</a> <button type=submit class=\"btn btn-lg btn-primary\" ng-disabled=editcategoryCtrl.editcategoryForm.$invalid>Save</button></div></formly-form></form></div></div><script type=text/ng-template id=categoryModal.html><div class=\"modal-header\">\n      <h3 class=\"modal-title\" id=\"modal-title\">{{ categoryModalCtrl.alert.title }}</h3>\n    </div>\n    <div class=\"modal-body\" id=\"modal-body\">\n      {{ categoryModalCtrl.alert.body }}\n    </div>\n    <div class=\"modal-footer\">\n      <button class=\"btn btn-primary\" type=\"button\" ng-show=\"categoryModalCtrl.alert.showOk\" ng-click=\"categoryModalCtrl.ok()\">OK</button>\n      <button class=\"btn btn-warning\" type=\"button\" ng-click=\"categoryModalCtrl.cancel()\">Cancel</button>\n    </div></script>");
$templateCache.put("app/pages/editresource/editresource.html","<div class=\"maincol col-md-12\"><h2><span ng-show=editresourceCtrl.isExisting>Edit \"{{ editresourceCtrl.resource.title }}\" </span><span ng-show=\"editresourceCtrl.isExisting !== true\">New Resource </span><span ng-show=editresourceCtrl.editresourceForm.$pristine>&nbsp;<a class=\"btn btn-info\" ui-sref=admin.resources>Resources</a> </span><span ng-show=\"editresourceCtrl.resource.id && editresourceCtrl.editresourceForm.$pristine\">&nbsp;<a class=\"btn btn-info\" ui-sref=\"resource({resourceSlug: editresourceCtrl.resource.slug})\">View</a> </span><span ng-show=\"editresourceCtrl.resource.id && editresourceCtrl.editresourceForm.$pristine\">&nbsp;<a class=\"btn btn-info\" ng-click=editresourceCtrl.deleteResource()>Delete Resource</a></span></h2><div ng-show=editresourceCtrl.resourceMessage class=alert ng-class=editresourceCtrl.resourceClass>{{ editresourceCtrl.resourceMessage }}</div><form class=resource-form ng-submit=editresourceCtrl.onEditSubmit() name=editresourceCtrl.editresourceForm novalidate><div class=col-md-8><formly-form model=editresourceCtrl.resource fields=editresourceCtrl.formFields form=editresourceCtrl.editresourceForm><div class=text-right><button type=submit class=\"btn btn-lg btn-primary\" ng-disabled=editresourceCtrl.editresourceForm.$invalid>Save</button></div></formly-form></div></form><div class=col-md-4><div class=feature-image><h3>Featured Image <a class=btn ng-click=editresourceCtrl.chooseUpdateImage() ng-if=\"editresourceCtrl.resource.feature.url !== null\">update</a> <a class=btn ng-click=editresourceCtrl.removeImage() ng-if=\"editresourceCtrl.resource.feature.url !== null\">remove</a> <a class=btn ng-click=editresourceCtrl.chooseNewImage() ng-if=\"editresourceCtrl.resource.feature.url === null\">new</a></h3><div ng-show=editresourceCtrl.resource.feature.url><img ng-src=\"{{ editresourceCtrl.resource.feature.url }}\"></div><p>{{ editresourceCtrl.resource.feature.url }}</p><div class=well ng-if=\"editresourceCtrl.mediaToEdit !== null\"><form class=media-form ng-submit=editresourceCtrl.onImageSubmit() name=editresourceCtrl.editmediaForm novalidate><formly-form model=editresourceCtrl.mediaToEdit fields=editresourceCtrl.mediaFormFields form=editresourceCtrl.editmediaForm><div class=text-right><button type=submit class=\"btn btn-lg btn-primary\" ng-disabled=editresourceCtrl.editmediaForm.$invalid>Upload</button></div></formly-form></form></div></div><hr><h3>Categories</h3><ul class=available-categories><li class=parent-category ng-repeat=\"category in editresourceCtrl.resource.availableCategories\">{{ category.cat_name }}<ul><li class=child-category ng-repeat=\"child in category.children\"><div ng-click=editresourceCtrl.toggleCategory(child)><i class=\"selected-item fa fa-check-circle\" ng-show=child.selected aria-hidden=true></i>{{ child.cat_name }}</div></li></ul></li></ul></div></div>");
$templateCache.put("app/pages/home/home.html","<div class=\"subcol col-md-4 col-md-push-8\"><div class=row ng-show=home.user.loggedIn><div class=subcol-element ng-show=home.user.user.fullMember><a ui-sref=\"resource({resourceSlug: \'team-manual\'})\" class=\"btn btn-info btn-fullsize\"><i class=\"fa fa-file-text-o\" aria-hidden=true></i> Download Team Manual</a></div><div class=subcol-element ng-hide=home.user.user.fullMember><a ui-sref=\"profile({formtype: \'upgrade\'})\" class=\"btn btn-info btn-fullsize\"><i class=\"fa fa-file-text-o\" aria-hidden=true></i> Upgrade your membership</a></div></div><div class=row ng-hide=home.user.loggedIn><div class=\"subcol-element text-center\"><div class=\"hidden-md hidden-lg\"><a ng-click=vm.openLogin() class=\"btn btn-inverse btn-fullsize\"><i class=\"fa fa-user\" aria-hidden=true></i> Login </a><br></div><a ng-click=home.openSignup() class=\"btn btn-info btn-fullsize\"><i class=\"fa fa-file-text-o\" aria-hidden=true></i> Join for Free</a></div></div><vg-category-grid category-slug=\"{{ home.categorySlug }}\" template-type=list>Loading...</vg-category-grid></div><div class=\"maincol col-md-8 col-md-pull-4\"><div class=page-intro ng-hide=home.user.loggedIn><h3>Welcome to the Vine Project Resource Library</h3><p>Once you join, you will have access to a growing library of resources to support you in disciple-making culture change in your church or organisation.</p></div><div class=well ng-if=\"home.interface.homeNewLibrary && home.user.loggedIn != true\"><h3><i class=\"fa fa-info-circle\" aria-hidden=true></i> New Login Details</h3><p>This is a new version of the Resource Library. We\'ve carried your login details across from the old one. All you need to do is set a password.<ul><li>If you had already registered you should have received an email with a link to create your password.</li><li>If you haven\'t received the email yet, please check your spam or <a ui-sref=password-reset()>enter your email address here</a></li><li>If you haven\'t signed up yet, you can <a ng-click=home.openSignup()>Register Now for Free</a></li></ul></p><br></div><h3>Featured Resource</h3><vg-resource-grid resources=home.resources></vg-resource-grid><div class=clearfix></div></div>");
$templateCache.put("app/pages/media/media.html","<div class=\"media-grid maincol col-md-8\"><h2>Media <a class=\"btn btn-lg btn-default\" ng-click=mediaCtrl.addNewImage()>Add New</a></h2><ul class=available-categories><li class=\"media-item col-md-3 col-xs-4\" ng-repeat=\"media in mediaCtrl.medias\"><a ng-click=mediaCtrl.editMedia(media)><div class=\"media-img img-crop-narrow\"><img ng-src=\"{{ media.url }}\" alt=\"{{ media.filename }}\"></div><div class=details><div class=caption><h5>{{ media.title }}</h5><h6>{{ media.filename }}</h6></div></div></a></li></ul><div class=clearfix></div><ul uib-pagination items-per-page=mediaCtrl.medias.pagination.per_page total-items=mediaCtrl.medias.pagination.total ng-model=mediaCtrl.pagination ng-change=mediaCtrl.pageChanged()></ul></div><div class=\"subcol col-md-4\"><div class=well ng-if=\"mediaCtrl.mediaToEdit === null\"><strong>Select a media Item to make changes</strong></div><div class=\"edit-media well\" ng-if=\"mediaCtrl.mediaToEdit !== null\"><form class=media-form ng-submit=mediaCtrl.onEditSubmit() name=mediaCtrl.editmediaForm novalidate><formly-form model=mediaCtrl.mediaToEdit fields=mediaCtrl.formFields form=mediaCtrl.editmediaForm><div class=text-right><a class=\"btn btn-lg btn-default\" ng-click=mediaCtrl.removeImage() ng-if=mediaCtrl.mediaToEdit.url>Remove</a> <button type=submit class=\"btn btn-lg btn-primary\" ng-disabled=mediaCtrl.editmediaForm.$invalid>Save</button></div></formly-form></form><hr><p>url: {{ mediaCtrl.mediaToEdit.url }}</p><img ng-src=\"{{ mediaCtrl.mediaToEdit.url }}\" alt=\"{{ mediaCtrl.mediaToEdit.filename }}\"></div></div>");
$templateCache.put("app/pages/membership/membership.html","<div class=\"maincol col-xs-12\"><div class=\"panel panel-default\"><div class=panel-heading><h3 class=panel-title>Join \'The Vine Project\'</h3></div><div class=panel-body><div ng-if=\"membershipCtrl.page == \'form\'\"><vg-form-signup form-type={{membershipCtrl.formtype}}></vg-form-signup></div><div ng-if=\"membershipCtrl.page == \'info\'\"><div class=text-center ng-hide=vm.user.loggedIn><a class=small ng-click=vm.openLogin()>Already a member? Login</a><br>&nbsp;<br></div><div class=membership-table><div class=\"row double-gap-top\"><div class=container-fluid><!-- <div class=\"col-md-4 first-col no-hover\">\n                <div class=\"heading clearfix\">\n                  <h5>Resources</h5>\n                </div>\n                <div class=\"price-box clearfix\">\n                  <ul class=\"no-list-style price-box no-margin striped-ul text-left\">\n                    <li>Disciple-Making Articles</li>\n                    <li>Disciple-Making Podcasts</li>\n                    <li>Pathway Resources</li>\n                    <li>Subscription to Gotherefor.com articles</li>\n                    <li>The Vine Project Team Manual</li>\n                    <li>Real World Stories</li>\n                    <li>Common Roadblocks</li>\n                    <li>The Vine Project Phase Resources</li>\n                    <li>Ongoing Support from The Vine Project Team</li>\n                    <li>Access to thevineproject.com community</li>\n                    <li>Access to The Vine Project Facebook Group</li>\n                  </ul>\n                </div> \n              </div>--><div class=col-md-6><div class=\"heading clearfix inverse bg-midnight-blue\"><h4>Lite Membership</h4></div><div class=\"price-box clearfix\"><ul class=\"no-list-style no-margin striped-ul\"><li><i class=\"fa fa-check\" aria-hidden=true></i> Disciple-Making Articles</li><li><i class=\"fa fa-check\" aria-hidden=true></i> Limited access to Disciple-Making Podcasts</li><li><i class=\"fa fa-check\" aria-hidden=true></i> Pathway Resources</li><li><i class=\"fa fa-check\" aria-hidden=true></i> Free to Join</li><!-- <li><i class=\"fa fa-check\" aria-hidden=\"true\"></i></li>\n                    <li><i class=\"fa fa-check\" aria-hidden=\"true\"></i> (limited)</li>\n                    <li><i class=\"fa fa-check\" aria-hidden=\"true\"></i></li>\n                    <li><i class=\"fa fa-close\" aria-hidden=\"true\"></i></li>\n                    <li><i class=\"fa fa-close\" aria-hidden=\"true\"></i></li>\n                    <li><i class=\"fa fa-close\" aria-hidden=\"true\"></i></li>\n                    <li><i class=\"fa fa-close\" aria-hidden=\"true\"></i></li>\n                    <li><i class=\"fa fa-close\" aria-hidden=\"true\"></i></li>\n                    <li><i class=\"fa fa-close\" aria-hidden=\"true\"></i></li>\n                    <li><i class=\"fa fa-close\" aria-hidden=\"true\"></i></li>\n                    <li><i class=\"fa fa-close\" aria-hidden=\"true\"></i></li> --></ul></div><div class=join-btn><a href=\"\" ui-sref=join.lite class=\"btn btn-block btn-inverse btn-flat\"><span>Join Free Now</span></a></div></div><div class=col-md-6><div class=\"heading clearfix inverse bg-col-primary\"><h4>Full Membership</h4></div><div class=\"price-box clearfix\"><ul class=\"no-list-style no-margin striped-ul\"><li><i class=\"fa fa-check\" aria-hidden=true></i> Everything in Lite, plus...</li><li><i class=\"fa fa-check\" aria-hidden=true></i> Full access to Disciple-Making Podcasts</li><li><i class=\"fa fa-check\" aria-hidden=true></i> Subscription to Gotherefor.com articles</li><li><i class=\"fa fa-check\" aria-hidden=true></i> The Vine Project Team Manual</li><li><i class=\"fa fa-check\" aria-hidden=true></i> Real World Stories</li><li><i class=\"fa fa-check\" aria-hidden=true></i> Common Roadblocks</li><li><i class=\"fa fa-check\" aria-hidden=true></i> The Vine Project Phase Resources</li><li><i class=\"fa fa-check\" aria-hidden=true></i> Ongoing Support from The Vine Project Team</li><li><i class=\"fa fa-check\" aria-hidden=true></i> Access to thevineproject.com community</li><li><i class=\"fa fa-check\" aria-hidden=true></i> Access to The Vine Project Facebook Group</li><li><i class=\"fa fa-check\" aria-hidden=true></i> Free to Join</li></ul></div><div class=join-btn><a href=\"\" ui-sref=join.full class=\"btn btn-block btn-info btn-flat\" style=\"padding: 8px 14px\"><span>Join Free Now</span></a></div></div></div><div class=\"text-center double-gap-top\"><p>To join as a Full Member please click the green join button and check the \'Full Membership\' box in the form.</p></div></div></div></div></div></div></div>");
$templateCache.put("app/pages/password/change.html","<!-- Password Reset Form --><div class=\"well col-md-6 col-md-offset-3\"><h1>Password Reset</h1><div ng-show=passCtrl.messageMessage class=alert ng-class=passCtrl.messageClass>{{ passCtrl.messageMessage }}</div><form ng-submit=passCtrl.onChangeSubmit() name=passCtrl.passwordChangeForm novalidate><formly-form model=passCtrl.model fields=passCtrl.passwordChangeFields form=passCtrl.passwordChangeForm><div class=text-right><button type=submit class=\"btn btn-lg btn-primary\" ng-disabled=passCtrl.passwordChangeForm.$invalid>Reset Password</button></div></formly-form></form></div>");
$templateCache.put("app/pages/password/reset.html","<!-- Password Reset Form --><div class=\"well col-md-6 col-md-offset-3\"><h1>Forgot Password?</h1><div ng-show=passCtrl.messageMessage class=alert ng-class=passCtrl.messageClass>{{ passCtrl.messageMessage }}</div><form ng-submit=passCtrl.onResetSubmit() name=passCtrl.passwordResetForm novalidate><formly-form model=passCtrl.model fields=passCtrl.passwordResetFields form=passCtrl.passwordResetForm><div class=text-right><button type=submit class=\"btn btn-lg btn-primary\" ng-disabled=passCtrl.passwordResetForm.$invalid>Request Password Reset Email</button></div></formly-form></form></div>");
$templateCache.put("app/pages/profile/profile.html","<div class=\"maincol col-xs-12 col-md-8 col-md-offset-2\"><div ng-show=vm.user.loggedIn class=\"panel panel-default\"><div class=panel-heading><h3 class=panel-title>{{ vm.user.user.firstname }}\'s Profile</h3></div><div class=panel-body><div ng-show=\"profileCtrl.formtype==\'upgrade\'\" class=\"alert alert-info\"><h3>To Upgrade your Membership</h3><p>To enable access to the Team Manual and more resources and allow our team to work alongside you to help you succeed, we\'ll need a little more information.</p><p><strong>Upgrading your membership will not cost you anything</strong></p><p>Please check the box \'Team Membership: I plan to start The Vine Project with my Church/Organisation\' and fill in the additional fields</p></div><vg-form-signup form-type={{profileCtrl.formtype}}></vg-form-signup></div></div><div class=well ng-hide=vm.user.loggedIn><strong>Please log in to access this page</strong></div></div>");
$templateCache.put("app/pages/resource/resource.html","<div class=\"maincol col-xs-12 col-lg-8\"><article><div class=article-meta><h2>{{ resource.title }} <a ng-show=resource.canEdit class=\"btn btn-primary\" ui-sref=\"admin.editresource({resourceSlug: resource.slug})\">Edit</a></h2><span>{{ resource.author.name }} | {{ resource.published }}</span><div class=categories><a ng-repeat=\"category in resource.categories\" ui-sref=\"category({ categorySlug: category.slug })\" class=\"label label-default\">{{ category.name }}</a><div class=clearfix></div></div></div><div class=article-body><div class=\"article-img img-crop-narrow\" ng-if=\"resource.hide_feature==false\"><img ng-src=\"{{ resource.feature }}\"></div><div ta-bind ng-model=resource.content></div><br><hr>&copy; Vinegrowers {{ resource.currentYear }}</div></article><div class=\"author-bio media\"><div class=media-left><a href=#><img class=\"media-object img-circle\" ng-src=\"{{ resource.author.thumbnail }}\" alt=\"{{ resource.author.name }}\"></a></div><div class=media-body><h4 class=media-heading>About {{ resource.author.name }}</h4>{{ resource.author.bio }}</div></div></div><div class=\"subcol col-xs-12 col-lg-4\"><!-- <vg-sidebar></vg-sidebar> --><vg-comments comments=resource.comments resource=resource></vg-comments></div>");
$templateCache.put("app/pages/search/search.html","<div class=\"maincol col-md-8\"><h3>Search Results</h3><div class=page-intro ng-if=\"searchCtrl.results.length === 0 && searchCtrl.searching !== true\"><h5>No items found for your search</h5></div><div class=page-intro ng-show=searchCtrl.searching><h5>Searching...</h5></div><vg-resource-grid resources=searchCtrl.results></vg-resource-grid><div class=clearfix></div></div>");}]);